import React from "react";
import { push } from "connected-react-router";
import _, { compact } from "lodash";
import Path from "path-parser";
import { FaCalendarAlt, FaUserEdit, FaStopwatch, FaClipboardList, FaRegFileCode, FaVectorSquare, FaUsers, FaBookOpen, FaHandHoldingUsd, FaAtlas, FaCogs, FaHeadphones, FaBug, FaCertificate, FaUsb, FaUserGraduate, FaBookReader, FaBuilding, FaBezierCurve, FaCity, FaPhabricator, FaPlug, FaPhoneVolume, FaUserSecret, FaServicestack } from "react-icons/fa";
import { GiTeacher } from "react-icons/gi";
import { AiFillAlert } from "react-icons/ai";
import { BiSupport } from "react-icons/bi";
import { RiCoinsFill } from "react-icons/ri";
import AllEmailSettings from "./containers/settings/email";
import AllSMSSettings from "./containers/settings/sms";
import AllWhatsAppSettings from "./containers/settings/whatsApp";
import AllInvoiceSettings from "./containers/settings/invoice";
import AllIncentiveSettings from "./containers/settings/incentive";
import FacebookCommunicationSettings from "./containers/settings/facebook";
import Dashboard from "./containers/dashboard/index";
import Timer from "./containers/dashboard/Timer"
import AllCountry from "./containers/Masters/country/all";
import AllFaculty from "./containers/Masters/faculty/all";
import AddCountry from "./containers/Masters/country/add/index copy.js";
import ProcessCountry from './containers/Masters/country/process'
import AddUniversity from "./containers/Masters/university/add";
import AddLevel from "./containers/Masters/level/add";
import AddVisaCategory from "./containers/Masters/visaCategory/add";
import AddCampus from "./containers/Masters/campus/add";
import AddCourse from "./containers/Masters/course/add";
import AddPartner from "./containers/Masters/partner/add";
import AddBranch from "./containers/Masters/branch/add";
import UpdateBranch from "./containers/Masters/branch/add/update.js";
import AddSubAgent from "./containers/Masters/subAgent/add";
import VisaInquiryType from "./containers/visaEnquiry/type/index.js";
import StaffSalarySlips from "./containers/payrollManagement/staffSalarySlips.js";
import IncentiveInvoice from "./containers/Desk/incentiveInvoice/index.js";
import PreviousIncentives from "./containers/incentive/previousIncentives/index.js";
import AddBoard from "./containers/Masters/board/add";
import AllBoardRankings from "./containers/Masters/boardRankings";
import AllBoardCategories from "./containers/Masters/boardCategories";
import AllGenders from "./containers/Masters/gender";
import AllDocumentTypes from "./containers/Masters/documentTypes/index.js";
import AllMaritalStatus from "./containers/Masters/maritalStatus";
import AllFollowupTypes from './containers/Masters/followUp';
import AllTestTypes from "./containers/Masters/testTypes";
import AddRestrictedLocations from "./containers/Masters/restrictedLocations/add";
import AddRestrictedUniversities from "./containers/Masters/restrictedUniversity/add";
import BusinessProposals from './containers/Masters/businessProposal/all/index.js'
import AddFaculty from "./containers/Masters/faculty/add";
import AddInquiry from "./containers/Student/inquiry/add";
// import AddInquiry from "./containers/Student/inquiry/add";
import AddRawInquiry from "./containers/Student/inquiry/add/rawInquiry";
import AllRawInquiry from "./containers/Student/inquiry/add/allRawInquiry";
import FacebookInquiry from './containers/socialEnquiry/facebook/index'
import GoogleInquiry from './containers/socialEnquiry/google/index'
import TransferCounsellor from "./containers/transferCounsellor/index";
import StaffSalaries from "./containers/payrollManagement/staffSalaries.js";
import UserSalary from "./containers/payrollManagement/userSalary.js";
import SalarySlip from './containers/payrollManagement/salarySlip.js';
import JobRoles from "./containers/payrollManagement/jobRoles.js";
import EmployeesPersonalPhones from './containers/payrollManagement/personalPhones.js';
import CountryReport from "./containers/Reports/countryReport";
import ActivityReport from "./containers/Reports/activityReport";
import BuisnessReport from "./containers/Reports/buisnessReport";
import GraphicalReport from "./containers/Reports/graphicalReport";
import UserWiseReport from "./containers/Reports/userwiseReport";
import LibraryReport from "./containers/Reports/libraryReport";
import DroppedLeads from "./containers/droppedLeads/index.js";
// import ForexVendorReports from "./containers/Reports/forexVendorReport.js"
import StudentReport from "./containers/Reports/studentReport";
import CourseReport from "./containers/Reports/courseReport";
import UniversityReport from "./containers/Reports/universityReport";
import ShiftTimings from "./containers/payrollManagement/shiftTimings.js";
import CountrywiseStudentReport from "./containers/Reports/countrywiseStudentReport.js";
import StudentDocument from "./containers/Student/documents";
import Activity from "./containers/activity/add/index";
import RatingHistory from "./containers/ratingHistory/add/index";
import StudentMoveReasons from "./containers/studentMoveReasons/add/index";
import Courier from "./containers/courier/add/index";
import PayrollSettings from "./containers/payrollManagement/payrollSettings.js";
import EditInq1 from "./containers/Student/inquiry/editInquiry";

import AllStudents from "./containers/Student/inquiry/all";
import AllReferrals from './containers/referrals/index.js'
import StudentSearch from "./containers/Student/inquiry/search";
import notificationTemplates from "./containers/notificationTemplates";
import UploadDocuments from "./containers/Student/upload/all";
import AllStates from "./containers/Masters/states/add";
import AllCities from "./containers/Masters/city/add";
import AllUniversities from "./containers/Masters/university/all";
import AllLevel from "./containers/Masters/level/all";
import AllVisaCategory from "./containers/Masters/visaCategory/all";
import AllPartner from "./containers/Masters/partner/all";
import AllCampus from "./containers/Masters/campus/all";
import AllCourse from "./containers/Masters/course/all";
import AllBranch from "./containers/Masters/branch/all";
import AllSubAgent from "./containers/Masters/subAgent/all";
import DocumentTemplates from "./containers/payrollManagement/documentSamples.js";
import FinanceWalletReport from './containers/finance/reports/walletReport.js';
import AllBoard from "./containers/Masters/board/all";
import AllRestrictedLocations from "./containers/Masters/restrictedLocations/all";
import AllRestrictedUniversities from "./containers/Masters/restrictedUniversity/all";
import RawInquiryFollowUps from './containers/FollowUp/rawInquiry/index.js';
import AllPlans from "./containers/Masters/plans";
import SubAgentPlans from './containers/Masters/agentPlans'
import SubAgentStudents from './containers/Masters/subAgent/students'
import AllVendors from "./containers/Masters/vendors";
import AllAccountPayments from "./containers/Desk/accountPayments";
import AllRatings from "./containers/Masters/ratings"
import LeadStatus from "./containers/Masters/leadStatus/index.js";
import allSubRatings from "./containers/Masters/subRatings"
import AllTemplate from "./containers/Template/all";
import AllFollowUp from "./containers/FollowUp/all";
import AllAssignedLeads from "./containers/assignedLeads/all"
import CounsellingDesk from "./containers/Desk/counselling/all";
import DeadCounsellingDesk from "./containers/Desk/deadCounselling/all";
import RegistrationDesk from "./containers/Desk/registration/all";
import ApplicationDesk from "./containers/Desk/application/all";
import VisaDesk from "./containers/Desk/visa/all";
import DeadStudent from "./containers/Desk/deadStudent/all";
import ClaimDesk from "./containers/Desk/claim/all";
import ArchiveDesk from "./containers/Desk/archive/all";
import AbsentStaff from './containers/payrollManagement/absentStaff'
import VendorReport from "./containers/Reports/vendorReport.js";
import InvoiceGenerated from "./containers/Desk/claim/all/allInvoiceToBeGenerated";
import DueInvoices from "./containers/Desk/claim/all/dueInvoices";
import BranchInvoices from "./containers/Desk/claim/all/branchInvoice";

import AddCounselling from "./containers/Desk/counselling/add";
import AddRegistrationFees from "./containers/Desk/registration/fees";
import CountryFact from "./containers/Masters/country/fact";
import UserManagement from "./containers/User";
import AddGroup from "./containers/group/add";
import AddFamilyFinance from "./containers/Desk/familyAndFinance/add";
import EditApplication from "./containers/Desk/application/editApplication";
import Enrollment from "./containers/Desk/application/enrolled";
import AddContactDetails from "./containers/contactDetails/add";
import VisaProcessing from "./containers/Desk/visa/visaProcessing";
import UpdateProfile from "./containers/User/updateProfile";
import ChangePassword from "./containers/User/changePassword";

import FullCalendarTaskManagement from "./containers/taskManagement/fullCalanderTaskManagement";
import studentDetailsDesign from "./containers/Student/inquiry/studentDetailsDesign";

import allNotAllowedIps from "./containers/IPManagement/all";
import AddIp from "./containers/IPManagement/add";

import AddVisaEnquiry from "./containers/visaEnquiry/add/index";
import AllVisaEnquiry from "./containers/visaEnquiry/all/index";
import AllGlobalExpoLeads from "./containers/globalExpoLeads/all/index";

import AllEmails from "./containers/adminCommunication/email/index";
import AllSms from "./containers/adminCommunication/sms/index";
import ClaimProcessing from "./containers/Desk/claim/claimProcessing/index";
import GenerateInvoice from "./containers/Desk/claim/claimProcessing/generateInvoice";
import UpdateGenerateInvoice from "./containers/Desk/claim/claimProcessing/updateGenerateInvoice";
import EditBranchInvoice from "./containers/Desk/claim/claimProcessing/editbranchInvoice";

import Appointment from "./containers/appointment/index";
import Telecaller from "./containers/telecaller";
import CourseFiltering from "./containers/Desk/courseFiltering";

import AddKnowledge from "./containers/knowledgeBase/add";
import ShowKnowledge from "./containers/knowledgeBase/show"
import AllKnowledge from "./containers/knowledgeBase/all";
import AddKnowledgeBaseCategory from "./containers/knowledgeBase/category/add";
import AllKnowledgeBaseCategory from "./containers/knowledgeBase/category/all";

import AllAutoFollowUp from "./containers/autoFollowUp/all";
import AddAutoFollowUp from "./containers/autoFollowUp/add";

import IncentiveDesk from "./containers/incentive/desk";
import PaymentDesk from "./containers/payment/desk";
import Notification from './containers/notifications/index'

import AllFinance from "./containers/finance/all";
import AllFinanceClaim from "./containers/finance/finance-claim"
import AllUniversityCommissions from "./containers/finance/university-commission";
import AllCourseCommission from "./containers/finance/course-commission";
import AllInvoices from "./containers/finance/invoices";
import AllFinanceWithdrawdesk from "./containers/finance/withdrawRequests"
import AllWithdrawFinalStage from "./containers/finance/withdrawFinalStage"
import AllWithdrawStudents from "./containers/finance/withdrawDesk"
import AllReports from "./containers/finance/reports";
import AllTaxes from "./containers/finance/taxes";
import AllCompanyDetails from "./containers/finance/companyDetails";
import AllInvoiceToDetails from "./containers/finance/invoiceToDetails"
import AllBranchInvoices from './containers/finance/branchInvoices';
import AllBranchClaimDesk from "./containers/finance/branchClaimDesk"
import AllFinanceBranchRequests from "./containers/finance/financeBranchRequests"

import AllOverallReports from "./containers/NewReports/overallReports";
import ApplicationsReports from "./containers/NewReports/applicationsReports";
import VisaDepartments from "./containers/NewReports/visaDepartment";
import TargetForCounsellor from "./containers/NewReports/counsellerTargets";
import InquiryConvertionReport from "./containers/NewReports/inquiryConvertionReport";
import DeadInquiryReport from "./containers/NewReports/deadInquiryReport";
import LetterOfIntent from "./containers/payrollManagement/letterOfIntent.js";
import OperationManagerDesk from "./containers/Desk/operationDesk/all";
import EditOperationManagerDesk from "./containers/Desk/operationDesk/edit";
import SubmitFees from "./containers/submitFees";
import AllEmployees from "./containers/payrollManagement/allEmployees";
import Announcements from "./containers/payrollManagement/announcements";

import AllHelpSuppport from "./containers/usefullPages/helpSupport"
import AllCompanyRules from "./containers/usefullPages/companyRules"
import AllStaffSuggestions from "./containers/usefullPages/staffSuggestions"
import ShowAllSuggestions from "./containers/usefullPages/showSuggestions"
import ShowRaisedSuggestions from "./containers/usefullPages/showSuggestions/raiseTicket"

import AllIVRSettings from "./containers/ivrManagement/ivrSettings"
import DirectCall from "./containers/ivrManagement/directCall"
import SearchLogs from "./containers/ivrManagement/searchLogs"
import AllSyncUsers from "./containers/ivrManagement/syncUsers";
import AllStatus from './containers/Masters/status/index.js'
import UniversityAgreementFollowUps from './containers/FollowUp/university/index.js';

import AllUserLoginHistory from "./containers/payrollManagement/userLoginHistory"
import AllStaffLoginHistory from "./containers/payrollManagement/staffLoginHistory"
import AllStaffOverallReport from "./containers/payrollManagement/staffOverallReport"
import AllGovtHolidays from "./containers/payrollManagement/govtHolidays";
import AllStaffSalaryManagement from "./containers/payrollManagement/StaffSalaryManagement";
import SupportStaffSalary from "./containers/payrollManagement/supportStaffSalary.js";
import Resignation from './containers/payrollManagement/resignation';
import StaffResignations from "./containers/payrollManagement/staffResignations";
import AppraisalRequests from "./containers/payrollManagement/appraisalRequests.js";

import AllConsortiums from "./containers/Masters/consortiums"

import AllAgreementManagement from "./containers/Masters/agreementManagement/all"
import allSource from "./containers/Masters/source";
import studentCallHistory from "./containers/studentCallHistory";
import LeaveApplication from './containers/payrollManagement/leaveApplication.js';
import StaffLeaves from './containers/payrollManagement/staffLeaves.js'
import TeamLeaves from "./containers/payrollManagement/teamLeaves.js";
import RegularisationRequests from "./containers/payrollManagement/regularisationRequests";
import StaffAppraisals from "./containers/payrollManagement/staffAppraisals";
import ViewAnnoucement from "./containers/payrollManagement/viewAnnoucement";
import UniversityPartnership from "./containers/Masters/university/partnership/index.js";
import TeamAppraisals from "./containers/payrollManagement/teamAppraisals.js";
import AppraisalsStaff from "./containers/payrollManagement/appraisalsStaff.js";

import AdvanceSettings from './containers/usefullPages/advanceSettings/index.js';
import Departments from "./containers/payrollManagement/departments.js";
import getSupport from "./containers/getSupport/index.js";
import AllTrainings from "./containers/training/index.js";
import LoyalitySettings from './containers/loyaltyProgram/details.js';
import LoyalityMembers from "./containers/loyaltyProgram/members.js";
import LoyalityCodes from './containers/loyaltyProgram/codes.js';
import ProgramSettings from './containers/loyaltyProgram/settings.js'
import CommunicationTriggers from "./containers/communicationTriggers/index.js";
import AccomodationServices from "./containers/usefullPages/accomodationServices/index.js";
import AccomodationServiceView from "./containers/accomodationService/index.js";
import CompanyAssets from "./containers/payrollManagement/companyAssets.js";
import EditInquiryV2 from "./containers/Student/inquiry/editInquiryV2.js";
import typeOfDegree from "./containers/Masters/typeOfDegree/index.js";
import qualificationScores from "./containers/Masters/qualificationScores/index.js";
import visaListFollowUp from "./components/_utils/visaListFollowUp.js";
import VisitorVisaFollowUp from './containers/FollowUp/visitorVisa/index.js'
import BusinessProposalFollowUps from './containers/FollowUp/businessProposal/index.js';
import CallsReport from "./containers/Reports/callsReport.js";
import OverallBusinessReport from "./containers/Reports/overallReport.js";
import CampaignHistory from './containers/campaigns/all/index.js';
import EmailCampaign from './containers/campaigns/email/index.js';
import WhatsappCampaign from './containers/campaigns/whatsapp/index.js';
import BusinessReport from "./containers/Reports/businessReport.js";
import MyStudents from "./containers/Student/inquiry/mystudents/index.js";
import StudentList from "./containers/Student/inquiry/list/index.js";
import MergeUniversity from './containers/Masters/university/merge/index.js';
import CounsellingConversionReport from './containers/Reports/counsellingConversionReport.js';
import StudentRecruitmentMetricsReport from "./containers/Reports/studentRecruitmentMetricsReport.js";
import CommunicationHistory from "./containers/communicationHistory/index.js";
import StaffInOutTime from './containers/payrollManagement/staffInOutTime.js';
import countrywiseStudentReport from "./containers/Reports/countrywiseStudentReport.js";
import VisitorVisaReport from "./containers/Reports/visitorVisaReport.js";
import leadSettings from "./containers/Masters/leadSettings/index.js";
import StaffDirectory from "./containers/contactDetails/staffDirectory/index.js";
import GroupedInvoices from "./containers/finance/invoices/groupedInvoices.js";
import ConversionReport from "./containers/Reports/conversionReport.js";
import CounsellorConversionReport from "./containers/Reports/counsellorConversionReport.js";
import StaffApologies from "./containers/payrollManagement/staffApologies.js";
import FollowUpPostponeRequest from './containers/FollowUp/requests/index.js';
import consultancyFeeReport from "./containers/Reports/consultancyFeeReport.js";
import counsellorPerformanceReport from "./containers/Reports/counsellorPerformanceReport.js";
import counsellorDailyReport from "./containers/Reports/counsellorDailyReport.js";
import VisaDepartmentReport from './containers/Reports/visaReport.js';
import UniversityCommission from "./containers/finance/university-commission/list.js";
import visaApprovalReport from "./containers/Reports/visaApprovalReport.js";
import visaSubmissionApprovalReport from "./containers/Reports/visaSubmissionApprovalReport.js";
import BonusInvoices from "./containers/finance/invoices/bonusInvoices.js";
import ChannelPartnerCommission from "./containers/finance/channel-partner-commission/list.js";
import StudentAccountReport from "./containers/Reports/studentAccountReport.js";
import UniversityAccountReport from "./containers/Reports/universityAccountReport.js";
import ChannelPartnerAccountReport from "./containers/Reports/channelPartnerAccountReport.js";
import BranchAccountReport from "./containers/Reports/branchAccountReport.js";
import RawInquiryList from "./containers/Student/inquiry/add/rawInquiryList.js";

let localUser = JSON.parse(localStorage.getItem('user'))

const menu = [
    // Timer
    {
        path: "/timer",
        name: "Timer",
        icon: (
            <i className={"anticon"}>
                <FaStopwatch />
            </i>
        ),
        key: "timer",
        title: "Timer",
        homepage: true,
        component: Timer,
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        subRights: [],
    },
    // Dashboard
    {
        path: "/dashboard",
        name: "Dashboard",
        icon: "dashboard",
        key: "dashboard",
        title: "Dashboard",
        homepage: true,
        component: Dashboard,
        authority: ["admin", "user"],
        subRights: [],
    },
    // Notifications
    {
        path: "/allnotifications",
        name: "Notifications",
        icon: "notification",
        key: "notification",
        title: "Notifications",
        dontShowOnMenu: true,
        component: Notification,
        authority: ["admin", "user"],
        subRights: [],
    },
    // Help & Support
    {
        path: "/help-support",
        icon: (
            <i className={"anticon"}>
                <FaAtlas />
            </i>
        ),
        title: "Company Management",
        name: "Company Management",
        key: "usefull-links",
        authority: ["admin", "user"],
        subRights: [
            "helpSupport.view",
            "AdvanceSettings.view",
            "accomodationServices.view"
        ],
        children: [
            {
                path: "/advance-settings",
                name: "Advance Settings",
                title: "Advance Settings",
                key: "AdvanceSettings",
                component: AdvanceSettings,
                rights: "AdvanceSettings.view"
            },
            {
                path: "/help-support",
                name: "Rules",
                title: "Rules",
                key: "help-support",
                component: AllHelpSuppport,
                rights: "helpSupport.view",
            },
            // {
            //     path: '/accomodation-services',
            //     name: 'Accomodation Services',
            //     title: 'Accomodation Services',
            //     component: AccomodationServices,
            //     rights: 'accomodationServices.view'
            // }
        ]
    },
    // Task Management
    {
        path: "/task",
        name: "Task Management",
        key: "task",
        icon: (
            <i className={"anticon"}>
                <FaClipboardList />
            </i>
        ),
        title: "Task Management",
        component: FullCalendarTaskManagement,
        dontShowOnMenu: true,
        authority: ["admin", "user"],
        rights: "Task.view",
        subRights: ["Task.view"],
    },
    {
        path: '/management',
        name: 'Management',
        key: 'management',
        icon: (
            <i className={"anticon"}>
                <FaAtlas />
            </i>
        ),
        authority: ["admin", "user"],
        children: [
            {
                path: "/agreement-management",
                name: "Agreement",
                key: "transfer",
                icon: (
                    <i className={"anticon"}>
                        <FaBookReader />
                    </i>
                ),
                title: "Agreement",
                authority: ["admin", "user"],
                // component: AllAgreementManagement,
                rights: "AgreementManagement.view",
                subRights: [],
            },
            {
                path: "/all-branch",
                icon: (
                    <i className={"anticon"}>
                        <FaCity />
                    </i>
                ),
                name: "Branch",
                title: "Branch",
                key: "user",
                authority: ["admin", "user"],
                subRights: ["plans.view", "Branch.view"],
                children: [
                    {
                        path: "/master/add-branch",
                        name: "Add",
                        title: "Add",
                        key: "addBranch",
                        // component: AddBranch,
                        rights: "Branch.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/all-branch",
                        name: "Branches",
                        title: "Branches",
                        // component: AllBranch,
                        rights: "Branch.view",
                    },
                    {
                        path: "/master/edit-branch",
                        name: "Edit",
                        title: "Edit",
                        key: "editBranch",
                        // component: AddBranch,
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/branch/plans",
                        name: "Plans",
                        title: "Plans",
                        key: "branchPlans",
                        // component: AllPlans,
                        rights: "plans.view",
                    },
                ]
            },
            {
                path: "/add-partner",
                icon: (
                    <i className={"anticon"}>
                        <FaUsers />
                    </i>
                ),
                name: "Channel Partner",
                title: "Channel Partner",
                key: "user",
                authority: ["admin", "user"],
                subRights: ["ChannelPartner.view"],
                children: [
                    {
                        path: "/master/add-partner",
                        name: "Add Channel Partner",
                        title: "Add Channel Partner",
                        key: "addPartner",
                        // component: AddPartner,
                        rights: "ChannelPartner.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/edit-partner",
                        name: "Edit Channel Partner",
                        title: "Edit Channel Partner",
                        key: "editPartner",
                        // component: AddPartner,
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/all-partner",
                        name: "List",
                        title: "List",
                        // component: AllPartner,
                        rights: "ChannelPartner.view",
                    }
                ]
            },
            {
                path: "/updateProfile",
                icon: (
                    <i className={"anticon"}>
                        <FaUserEdit />
                    </i>
                ),
                name: "Employee",
                title: "Employee",
                key: "profile-management",
                authority: ["admin", "user"],
                subRights: [],
                children: [
                    {
                        path: "/updateProfile",
                        name: "Update Profile",
                        title: "Update Profile",
                        key: "updateProfile",
                        // component: UpdateProfile
                    },
                    {
                        path: "/changePassword",
                        name: "Change Password",
                        title: "Change Password",
                        key: "changePassword",
                        // component: ChangePassword
                    },
                    {
                        path: "/leave-applications",
                        name: "Leave Applications",
                        title: "Leave Applications",
                        // component: LeaveApplication,
                    },
                    {
                        path: "/resignation",
                        name: "Resignation",
                        title: "Resignation",
                        // component: Resignation
                    },
                    {
                        path: "/salary-slip",
                        name: "Request Salary Slip",
                        title: "Request Salary Slip",
                        // component: SalarySlip
                    },
                    {
                        path: "/team-leaves",
                        name: "Team Leaves",
                        title: "Team Leaves",
                        // component: TeamLeaves,
                        dontShowOnMenu: (localUser && localUser.isHOD ? false : true)
                    },
                    {
                        path: "/team-appraisals",
                        name: "Team Appraisals",
                        title: "Team Appraisals",
                        // component: TeamAppraisals,
                        dontShowOnMenu: (localUser && localUser.isHOD ? false : true)
                    },
                    {
                        path: "/login-history",
                        name: "Login History",
                        key: "login-history",
                        title: 'Login History',
                        // component: AllUserLoginHistory,
                        rights: "userLoginHistory.view",
                    },
                    {
                        path: '/view-annoucements',
                        name: 'View Annoucements',
                        key: 'view-announcements',
                        title: 'View Annoucements',
                        // component: ViewAnnoucement
                    },
                    {
                        path: '/appraisal-requests',
                        name: 'Appraisal Request',
                        key: 'Appraisal Request',
                        title: 'Appraisal Request',
                        // component: AppraisalRequests
                    },
                    {
                        path: '/salary',
                        name: 'Review Salary',
                        key: 'Salary Details',
                        title: 'Review Salary',
                        // component: UserSalary
                    },
                    {
                        path: "/desk/incentive-invoice",
                        name: "Incentive Invoice",
                        title: "Incentive Invoice",
                        // component: IncentiveInvoice,
                        rights: "IncentiveInvoice.view",
                    },
                    {
                        path: "/desk/incentive",
                        name: "Incentive Desk",
                        title: "Incentive Desk",
                        // component: IncentiveDesk,
                        key: "incentiveDesk",
                        rights: "IncentiveDesk.view",
                    },
                    {
                        path: '/personal-phones',
                        name: 'Employee Phones',
                        title: 'Employee Phones',
                        // component: EmployeesPersonalPhones,
                        rights: 'employeesPhones.view'
                    },
                    {
                        path: '/staff-in-out-time',
                        name: 'Staff In Out Time',
                        title: 'Staff In Out Time',
                        // component: StaffInOutTime,
                        rights: 'staffInOutTime.view'
                    },
                    {
                        path: '/staff-apology',
                        name: 'Apology',
                        title: 'Apology',
                        // component: StaffApologies,
                        rights: 'apology.view'
                    }
                ]
            },
            {
                path: "/finance",
                icon: (
                    <i className={"anticon"}>
                        <FaHandHoldingUsd />
                    </i>
                ),
                name: "Finance",
                key: "finance",
                title: "Finance",
                authority: ["admin"],
                subRights: [
                    "finance.view",
                    "financeUniversityCommission.view",
                    "financeCourseCommission.view",
                    "financeTax.view",
                    "financeCompanyDetails.view",
                    "CommunicationSetting.view",
                    "financeInvoiceTo.view",
                    "financeClaimDesk.view",
                    "financeInvoices.view",
                    "financeBranchClaimDesk.view",
                    "financeBranchInvoices.view",
                    "financeBranchRequests.view",
                    "pendingIncentives.view",
                ],
                children: [
                    {
                        path: '/invoices',
                        name: 'Invoices',
                        title: 'Invoices',
                        key: 'invoices',
                        subRights: [
                            "financeClaimDesk.view",
                            "financeInvoices.view",
                            "financeBranchInvoices.view"
                        ],
                        children: [
                            // {
                            //     path: "/account-desk",
                            //     name: "Generate New",
                            //     title: "Generate New",
                            //     key: "account-desk",
                            //     // component: AllFinance,
                            //     rights: "financeClaimDesk.view",
                            //     subRights: ["financeClaimDesk.view"]
                            // },
                            {
                                path: "/finance-desk",
                                name: "Final",
                                title: "Final",
                                key: "finance-invoices",
                                // component: AllInvoices,
                                rights: "financeInvoices.view"
                            },
                            {
                                path: "/invoices-desk",
                                name: "Bonus/Marketing",
                                title: "Bonus/Marketing",
                                key: "finance-invoices",
                                // component: AllInvoices,
                                rights: "financeInvoices.view"
                            },
                            {
                                path: "/finance-desk-performa",
                                name: "Performa",
                                title: "Performa",
                                key: "finance-desk-performa",
                                // component: AllInvoices,
                                rights: "financeInvoices.view",
                                subRights: ["financeInvoices.view"],
                            },
                            // {
                            //     path: "/finance-desk-invoice",
                            //     name: "Formal",
                            //     title: "Formal",
                            //     key: "finance-desk-invoice",
                            //     // component: AllInvoices,
                            //     rights: "financeInvoices.view",
                            //     subRights: ["financeInvoices.view"],
                            // },
                            // {
                            //     path: "/finance-branch-invoices",
                            //     name: "Branch",
                            //     title: "Branch",
                            //     key: "finance-branch-invoices",
                            //     // component: AllBranchInvoices,
                            //     rights: "financeBranchInvoices.view",
                            // },
                            // {
                            //     path: "/finance-desk-pending",
                            //     name: "Payment Pending",
                            //     title: "Payment Pending",
                            //     key: "finance-desk-pending",
                            //     // component: AllInvoices,
                            //     rights: "financeInvoices.view",
                            //     subRights: ["financeInvoices.view"],
                            // },
                            // {
                            //     path: "/finance-desk-received",
                            //     name: "Payment Received",
                            //     title: "Payment Received",
                            //     key: "finance-desk-received",
                            //     // component: AllInvoices,
                            //     rights: "financeInvoices.view",
                            //     subRights: ["financeInvoices.view"],
                            // },
                        ]
                    },
                    // {
                    //     path: '/grouped-performa-invoice',
                    //     name: "Grouped Performa Invoice",
                    //     title: 'Grouped Performa Invoice',
                    //     key: 'grouped-performa-invoice',
                    //     component: AllInvoices,
                    //     rights: "financeInvoices.view",
                    //     subRights: ["financeInvoices.view"],
                    // },


                    {
                        path: "/withdraw-desk",
                        name: "Withdrawn Students",
                        title: "Withdrawn Students",
                        subRights: [
                            "financeWithdrawDesk.view",
                            "financeWithdraw.view",
                            "financeWithdrawStudents.view",
                        ],
                        children: [
                            {
                                path: "/account-withdraw-desk",
                                name: "Withdrawal Review",
                                // name: "Account Withdraw Desk",
                                title: "Withdrawal Review",
                                key: "account-withdraw-desk",
                                // component: AllFinanceWithdrawdesk,
                                rights: "financeWithdrawDesk.view",
                            },
                            // {
                            //     path: "/finance-withdraw-requests",
                            //     name: "Student Withdrawals (Final Stage)",
                            //     title: "Student Withdrawals (Final Stage)",
                            //     key: "finance-withdraw-requests",
                            //     component: AllWithdrawFinalStage,
                            //     rights: "financeWithdraw.view",
                            // },
                            {
                                path: "/finance-withdraw-list",
                                name: "Withdrawn",
                                // name: "Non-Commissionable Students",
                                title: "Withdrawn",
                                key: "finance-withdraw-list",
                                // component: AllWithdrawStudents,
                                rights: "financeWithdrawStudents.view",
                            }
                        ]
                    },
                    {
                        path: "/finance-branch-requests",
                        name: "Branch Invoices to be paid",
                        title: "Branch Invoices to be paid",
                        key: "finance-branch-requests",
                        // component: AllFinanceBranchRequests,
                        rights: "financeBranchRequests.view",
                    },
                    {
                        path: "/finance-branch-claim-desk",
                        name: "Branch Claims",
                        title: "Branch Claims",
                        key: "finance-branch-claim-desk",
                        // component: AllBranchClaimDesk,
                        rights: "financeBranchClaimDesk.view",
                    },

                    {
                        path: "/company-details",
                        name: "Commission Information",
                        title: "Commission Inforamation",
                        subRights: [
                            "financeUniversityCommission.view",
                            "financeCourseCommission.view",
                            "financeTax.view",
                            "financeCompanyDetails.view",
                            "CommunicationSetting.view",
                            "financeInvoiceTo.view",
                            "pendingIncentives.view",
                        ],
                        children: [
                            // Pending Incentives
                            // {
                            //     path: "/pending-incentives",
                            //     name: "Previous Incentives",
                            //     title: "Previous Incentives",
                            //     // component: PreviousIncentives,
                            //     key: "previousIncentives",
                            //     rights: "pendingIncentives.view",
                            // },
                            // {
                            //     path: "/finance-university-commission",
                            //     name: "University Commission",
                            //     title: "University Commission",
                            //     key: "finance-university",
                            //     // component: AllUniversityCommissions,
                            //     rights: "financeUniversityCommission.view",
                            // },
                            {
                                path: "/university-commission",
                                name: "University Commission",
                                title: "University Commission",
                                key: "finance-university",
                                // component: UniversityCommission,
                                rights: "financeUniversityCommission.view",
                            },
                            {
                                path: '/channel-partner-commission',
                                name: 'Channel Partner Commission',
                                title: 'Channel Partner Commission',
                                key: 'channel-partner-commission',
                                // component: ChannelPartnerCommission,
                                rights: 'financeUniversityCommission.view'
                            },
                            {
                                path: "/finance-course-commission",
                                name: "Course Commission",
                                title: "Course Commission",
                                key: "finance-course",
                                // component: AllCourseCommission,
                                rights: "financeCourseCommission.view",
                            },
                            {
                                path: "/finance-tax",
                                name: "Tax",
                                title: "Tax",
                                key: "finance-tax",
                                // component: AllTaxes,
                                rights: "financeTax.view",
                            },
                            {
                                path: "/company-info",
                                name: "Company Info",
                                title: "Company Info",
                                key: "company-info",
                                // component: AllCompanyDetails,
                                rights: "financeCompanyDetails.view",
                            },
                            {
                                path: "/invoice-settings",
                                name: "Invoice Setting",
                                key: "InvoiceSettings",
                                title: 'Invoice',
                                // component: AllInvoiceSettings,
                                rights: "financeInvoiceSetting.view",
                            },
                            // {
                            //     path: "/invoice-to-details",
                            //     name: "Invoice Recipients",
                            //     title: "Invoice Recipients",
                            //     key: "invoice-to-details",
                            //     // component: AllInvoiceToDetails,
                            //     rights: "financeInvoiceTo.view",
                            // }
                        ]
                    }
                ]
            },
            {
                path: "/followUp",
                icon: (
                    <i className={"anticon"}>
                        <FaPhoneVolume />
                    </i>
                ),
                name: "Follow Up",
                key: "followUp",
                authority: ["admin", "user"],
                subRights: ["VisaFollowUps.view", "FollowUps.view"],
                children: [
                    {
                        path: '/followUp/student-followUp',
                        name: 'Student FollowUps',
                        title: 'Student FollowUps',
                        rights: "FollowUps.view",
                        // component: AllFollowUp,
                    },
                    {
                        path: '/followUp/visa-followUp',
                        name: 'Visitor Visa FollowUps',
                        title: 'Visitor Visa FollowUps',
                        rights: "VisaFollowUps.view",
                        // component: VisitorVisaFollowUp
                    },
                    {
                        path: '/followUp/business-proposal-followUp',
                        name: 'Business Proposal FollowUps',
                        title: 'Business Proposal FollowUps',
                        rights: "BusinessProposalsFollowUps.view",
                        // component: BusinessProposalFollowUps
                    },
                    {
                        path: '/followUp/university-agreement-followUp',
                        name: 'University Agreement FollowUps',
                        title: 'University Agreement FollowUps',
                        rights: 'universityAgreementFollowUps.view',
                        // component: UniversityAgreementFollowUps
                    },
                    {
                        path: '/followUp/raw-inquiry-followUp',
                        name: 'Raw Inquiry FollowUps',
                        title: 'Raw Inquiry FollowUps',
                        rights: 'rawInquiryFollowUps.view',
                        // component: RawInquiryFollowUps
                    },
                    {
                        path: '/followUp/postpone-requests',
                        name: 'PostPone Requests',
                        title: 'Postpone Requests',
                        rights: 'followUpPostponeRequest.view',
                        // component: FollowUpPostponeRequest,
                    }
                ]
            },
            {
                path: "/payroll-management",
                icon: (
                    <i className={"anticon"}>
                        <FaUserSecret />
                    </i>
                ),
                name: "HR",
                title: "HR",
                key: "payroll-management",
                subRights: [
                    'allEmployees.view',
                    'staffResignation.view',
                    "PayrollManagement.view",
                    "staffLoginHistory.view",
                    "govtHolidays.view",
                    "staffSalaryManagement.view",
                    "StaffLeaves.view",
                    "RegularisationRequests.view",
                    "companyAssets.view",
                    "jobRoles.view",
                    "announcements.view",
                    "letterOfIntent.view",
                    "payrollDocuments.view",
                    "shiftTimings.view",
                    "departments.view",
                ],
                authority: ["admin", "user"],
                children: [
                    {
                        path: "/branch-users",
                        name: "Employees",
                        title: "Employees",
                        // component: AllEmployees,
                        rights: 'allEmployees.view'
                    },
                    {
                        path: "/branch-users/edit-user",
                        name: "Edit Employee",
                        title: "Edit Employee",
                        key: "editUser",
                        dontShowOnMenu: true,
                        // component: AllEmployees,
                        rights: 'allEmployees.view'
                    },
                    {
                        path: "/staff-login-history",
                        name: "Staff Login History",
                        title: "Staff Login History",
                        // component: AllStaffLoginHistory,
                        rights: "staffLoginHistory.view",
                    },
                    {
                        path: "/letter-of-intent",
                        name: "Letter of Intent",
                        title: "Letter of Intent",
                        // component: LetterOfIntent,
                        rights: 'letterOfIntent.view'
                    },
                    {
                        path: "/staff-requests",
                        name: "Staff Requests",
                        title: "Staff Requests",
                        // component: RegularisationRequests,
                        rights: "RegularisationRequests.view"
                    },
                    // {
                    //     path: "/staff-leaves",
                    //     name: "Staff Leaves",
                    //     title: "Staff Leaves",
                    //     component: StaffLeaves,
                    //     rights:"StaffLeaves.view"
                    // },
                    // {
                    //     path: "/staff-appraisal",
                    //     name: "Staff Appraisals",
                    //     title: "Staff Appraisals",
                    //     component: AppraisalsStaff,
                    //     rights:"staffAppraisals.view"
                    // },
                    {
                        path: "/payroll-management",
                        name: "Staff Salary",
                        title: "Staff Salary",
                        // component: AllStaffOverallReport,
                        rights: "PayrollManagement.view",
                    },
                    {
                        path: "/annoucements",
                        name: "Announcements",
                        title: "Announcements",
                        // component: Announcements,
                        rights: 'announcements.view'
                    },
                    // {
                    //     path: "/staff-resignations",
                    //     name: "Staff Resignations",
                    //     title: "Staff Resignations",
                    //     component: StaffResignations,
                    //     rights:'staffResignation.view'
                    // },
                    {
                        path: "/govt-holidays",
                        name: "Holidays",
                        title: "Holidays",
                        // component: AllGovtHolidays,
                        rights: "govtHolidays.view",
                    },
                    {
                        path: "/attendance",
                        name: "Staff Attendance",
                        title: "Staff Attendance",
                        // component: AbsentStaff,
                        rights: 'attendance.view'
                    },
                    // {
                    //     path: "/staff-salaries",
                    //     name: "Staff Salaries",
                    //     title: "Staff Salaries",
                    //     component: StaffSalaries,
                    //     right:'staffSalaries.view'
                    // },
                    {
                        path: "/staff-slip-requests",
                        name: "Salary Slip Requests",
                        title: "Salary Slip Requests",
                        // component: StaffSalarySlips,
                        rights: 'salarySlipRequest.view'
                    },
                    {
                        path: "/payroll-documents",
                        name: "Payroll Documents",
                        title: "PayrollDocuments",
                        // component: DocumentTemplates,
                        rights: 'payrollDocuments.view'
                    },
                    // {
                    //     path: "/staff-salary-management",
                    //     name: "Salary Management",
                    //     title: "Salary Management",
                    //     component: AllStaffSalaryManagement,
                    //     rights: "staffSalaryManagement.view",
                    // },
                    // {
                    //     path:'/support-staff-salary',
                    //     name:'Support Staff Salary',
                    //     title:'Support Staff Salary',
                    //     component:SupportStaffSalary,
                    //     rights: "staffSalaryManagement.view",
                    // },
                    {
                        path: '/job-roles',
                        name: 'Job Roles',
                        title: 'Job Roles',
                        // component: JobRoles,
                        rights: "jobRoles.view",
                    },
                    {
                        path: '/company-assets',
                        name: 'Company Assets',
                        title: 'Company Assets',
                        // component: CompanyAssets,
                        rights: 'companyAssets.view'
                    },
                    {
                        path: '/payroll-settings',
                        name: 'Settings',
                        title: 'Settings',
                        // component: PayrollSettings,
                        rights: 'payrollSettings.view'
                    },
                    {
                        path: "/shift-timings",
                        name: "Shift Timings",
                        title: "Shift Timings",
                        // component: ShiftTimings,
                        right: 'shiftTimings.view'
                    },
                    {
                        path: '/departments',
                        name: 'Departments',
                        title: 'Departments',
                        // component: Departments,
                        right: 'departments.view'
                    },

                ],
            },
            {
                name: "IP / Securities",
                key: "ipManagement",
                icon: (
                    <i className={"anticon"}>
                        <FaPlug />
                    </i>
                ),
                authority: ["admin"],
                children: [
                    {
                        path: "/ip/add",
                        name: "Authorized IP`s",
                        title: "Authorized IP`s",
                        // component: AddIp,
                        rights: "IpManagement.add",
                    },
                    {
                        path: "/list/notAllowedIps",
                        name: "Unauthorized IP`s",
                        title: "Unauthorized IP`s",
                        key: "allNotAllowedIps",
                        // component: allNotAllowedIps,
                        rights: "IpManagement.view",
                    },
                ],
            },
            {
                path: "/lead-management",
                name: 'Lead',
                key: 'leadManagement',
                icon: (
                    <i className={"anticon"}>
                        <FaVectorSquare />
                    </i>
                ),
                authority: ["admin", "user"],
                subRights: [
                    "Student.view",
                    "Student.add",
                    "rawInquiry.view",
                    "rawInquiry.add",
                    "VisaEnquiry.add",
                    "VisaEnquiry.view",
                    "ratings.view",
                    "source.view",
                    "GenderDetails.view",
                    "MaritalStatus.view",
                    "followUpTypes.view",
                    "testTypes.view",
                    "documentTypes.view",
                    "leadSettings.view",
                    "SocialFacebook.view",
                    "SocialGoogle.view",
                    "showDropLead.view",
                    "TransferCounsellor.view",
                    "AssignedLeads.view",
                    "UploadDocuments.view",
                ],
                children: [
                    {
                        path: "/allLeads",
                        name: "Enquiries",
                        title: "Enquiries",
                        key: "inquiry",
                        rights: "Student.view",
                        // subRights: ["Student.view", "Student.add"],
                        // children: [
                        //     {
                        //         path: "/allLeads",
                        //         name: "List",
                        //         title: "List",
                        //         key: "leads",
                        //         // component: AllStudents,
                        //         rights: "Student.view",
                        //     },
                        // ]
                    },
                    {
                        path: "/raw/inquiry/all",
                        name: "Raw Enquiry",
                        title: "Raw Enquiry",
                        rights: "rawInquiry.view",
                        // children: [
                        //     {
                        //         path: "/raw/inquiry/all",
                        //         name: "List",
                        //         title: "List",
                        //         rights: "rawInquiry.view",
                        //         // component: AllRawInquiry,
                        //     },
                        // ]
                    },
                    {
                        path: "/visaEnquiry/all",
                        name: "Visitor Visa Enquiry",
                        title: "Visitor Visa Enquiry",
                        rights: "VisaEnquiry.view",
                        children: [
                            {
                                path: "/visaEnquiry/all",
                                name: "List",
                                title: "List",
                                // component: AllVisaEnquiry,
                                rights: "VisaEnquiry.view",
                            },
                            // {
                            //     path: "/visaEnquiry/approved",
                            //     name: "Approved",
                            //     title: "Approved",
                            //     component: AllVisaEnquiry,
                            //     rights: "VisaEnquiry.view",
                            // },
                            // {
                            //     path: "/visaEnquiry/dead",
                            //     name: "Dead",
                            //     title: "Dead",
                            //     component: AllVisaEnquiry,
                            //     rights: "VisaEnquiry.view",
                            // },
                            {
                                path: "/visaEnquiry/type",
                                name: "Type",
                                title: "Type",
                                // component: VisaInquiryType,
                            }
                        ]
                    },
                    {
                        path: "/campaigns/facebook",
                        name: "Campaign Leads",
                        key: "Integrations",
                        title: 'Campaign Leads',
                        subRights: [
                            "SocialFacebook.view",
                            "SocialGoogle.view",
                        ],
                        children: [
                            {
                                path: "/campaigns/facebook",
                                name: "Facebook",
                                title: "Facebook Lead",
                                // component: FacebookInquiry,
                                rights: "SocialFacebook.view"
                            },
                            {
                                path: "/campaigns/google",
                                name: "Google",
                                title: "Google Lead",
                                // component: GoogleInquiry,
                                rights: "SocialGoogle.view"
                            }
                        ]
                    },
                    {
                        path: '/lead-settings',
                        name: 'Lead Settings',
                        key: 'lead-settings',
                        title: 'Lead Settings',
                        subRights: [
                            "ratings.view",
                            "source.view",
                            "GenderDetails.view",
                            "MaritalStatus.view",
                            "followUpTypes.view",
                            "testTypes.view",
                            "documentTypes.view",
                            "leadSettings.view",
                        ],
                        children: [
                            {
                                path: "/other/ratings",
                                name: "Ratings",
                                title: "Ratings",
                                key: "allRatings",
                                // component: AllRatings,
                                rights: "ratings.view",
                            },
                            {
                                path: "/other/sub-ratings",
                                name: "Rating Tags",
                                title: "Rating Tags",
                                key: "allSubRatings",
                                // component: allSubRatings,
                                rights: "ratings.view",
                            },
                            {
                                path: "/other/source",
                                name: "Source",
                                title: "Source",
                                key: "allSource",
                                // component: allSource,
                                rights: "source.view",
                            },
                            {
                                path: "/other/genders",
                                name: "Genders",
                                title: "Genders",
                                key: "genders",
                                // component: AllGenders,
                                rights: "GenderDetails.view",
                            },
                            {
                                path: "/other/marital-status",
                                name: "Marital Status",
                                title: "Marital Status",
                                key: "maritalStatus",
                                // component: AllMaritalStatus,
                                rights: "MaritalStatus.view",
                            },

                            {
                                path: "/other/followup-types",
                                name: "Follow-up Tags",
                                title: "Follow-up Tags",
                                key: "followupTypes",
                                // component: AllFollowupTypes,
                                rights: "followUpTypes.view",
                            },
                            {
                                path: "/other/lead-status",
                                name: "Lead Status",
                                title: "Lead Status",
                                key: "leadStatus",
                                // component: LeadStatus,
                                rights: "leadStatus.view",
                            },
                            {
                                path: "/other/test-types",
                                name: "Test Types",
                                title: "Test Types",
                                key: "testTypes",
                                // component: AllTestTypes,
                                rights: "testTypes.view",
                            },
                            {
                                path: "/other/document-types",
                                name: 'Document Types',
                                title: 'Document Types',
                                key: 'documentTypes',
                                // component: AllDocumentTypes,
                                rights: "documentTypes.view"
                            },
                            {
                                path: "/other/lead-settings",
                                name: 'Settings',
                                title: 'Settings',
                                key: 'settings',
                                // component: leadSettings,
                                rights: "leadSettings.view"
                            }
                        ]
                    },
                    {
                        path: "/dropped-leads",
                        name: "Dropped Leads",
                        key: "dropped-leads",
                        title: "Dropped Leads",
                        authority: ["admin", "user"],
                        // component: DroppedLeads,
                        rights: "showDropLead.view",
                    },
                    {
                        path: "/lead-transfer",
                        name: "Lead Transfer",
                        key: "lead-transfer",
                        title: "Lead Transfer",
                        authority: ["admin", "user"],
                        // component: TransferCounsellor,
                        rights: "TransferCounsellor.view",
                    },
                    {
                        path: "/assigned-leads",
                        name: "Assigned Leads",
                        key: "assigned-leads",
                        title: "Assigned Leads",
                        authority: ["admin", "user"],
                        // component: AllAssignedLeads,
                        rights: "AssignedLeads.view",
                    },
                    {
                        path: '/lead-referrals',
                        name: "Referrals",
                        title: "Referrals",
                        key: 'referrals',
                        // component: AllReferrals
                    },
                    {
                        path: "/upload-documents",
                        name: "Upload Documents",
                        title: "Upload Documents",
                        key: "upload-documents",
                        // component: UploadDocuments,
                        rights: "UploadDocuments.view",
                    }
                ]
            },
            {
                path: "/master",
                icon: "database",
                name: "Master Data",
                key: "mastersManagement",
                authority: ["admin", "user"],
                subRights: [
                    "Country.view",
                    "State.view",
                    "City.view",
                    "vendors.view",
                    "ratings.view",
                    "source.view",
                    "status.view",
                    "GenderDetails.view",
                    "MaritalStatus.view",
                    "University.view",
                    "Campus.view",
                    "ChannelPartner.view",
                    "Course.view",
                    "Faculty.view",
                    "Level.view",
                    "Consortiums.view",
                    "RestrictedLocations.view",
                    "RestrictedLocalUniversity.view",
                    "Boards.add",
                    "BoardRankings.view",
                    "BoardCategories.view",
                    "AgreementManagement.view",
                    "followUpTypes.view"
                ],
                children: [
                    {
                        path: '/location',
                        name: 'Locations',
                        key: 'locations',
                        authority: ["admin", "user"],
                        children: [
                            {
                                path: "/location/all-country",
                                name: "All Countries",
                                title: "All Countries",
                                // component: AllCountry,
                                rights: "Country.view",
                            },
                            {
                                path: "/location/add-country",
                                name: "Add Country",
                                key: "addCountry",
                                title: "Add Country",
                                // component: AddCountry,
                                rights: "Country.add",
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/location/countryFactSheet",
                                name: "Country Fact Sheet",
                                key: "countryFactSheet",
                                title: "Country Fact Sheet",
                                // component: CountryFact,
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/location/edit-country",
                                name: "Edit Country",
                                title: "Edit Country",
                                key: "editCountry",
                                // component: AddCountry,
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/location/process-country",
                                name: "Process Country",
                                title: "Process Country",
                                key: "processCountry",
                                // component: ProcessCountry,
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/location/all-states",
                                name: "All States",
                                title: "All States",
                                // component: AllStates,
                                rights: "State.view",
                            },
                            {
                                path: "/location/all-cities",
                                name: "All Cities",
                                title: "All Cities",
                                // component: AllCities,
                                rights: "City.view",
                            },
                            {
                                path: "/master/all-restricted-locations",
                                name: "Restricted Locations",
                                title: "Restricted Locations",
                                // component: AllRestrictedLocations,
                                rights: "RestrictedLocations.view",
                            },
                            {
                                path: "/master/add-restricted-location",
                                name: "Add Restricted Location ",
                                title: "Add Restricted Location",
                                key: "addRestrictedLocation",
                                // component: AddRestrictedLocations,
                                rights: "RestrictedLocations.add",
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/master/edit-restricted-location",
                                name: "Edit Restricted Location",
                                title: "Edit Restricted Location",
                                key: "editRestrictedLocation",
                                // component: AddRestrictedLocations,
                                dontShowOnMenu: true,
                            },
                        ]
                    },
                    {
                        path: "/master",
                        name: "Institutions",
                        key: "masters",
                        authority: ["admin", "user"],
                        children: [
                            {
                                path: "/master/add-university",
                                name: "Add University",
                                title: "Add University",
                                // component: AddUniversity,
                                rights: "University.add",
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/master/all-universities",
                                name: "All Universities",
                                title: "All Universities",
                                rights: "University.view",
                                // component: AllUniversities,
                            },
                            {
                                path: "/master/edit-university",
                                name: "Edit University",
                                title: "Edit University",
                                key: "editUniversity",
                                // component: AddUniversity,
                                dontShowOnMenu: true,
                            },
                            {
                                path: '/master/merge-university',
                                name: 'Merge Universities',
                                title: 'Merge Universities',
                                // component: MergeUniversity,
                                rights: 'mergeUniversity.view'
                            },
                            {
                                path: "/master/add-campus",
                                name: "Add Campus",
                                title: "Add Campus",
                                key: "addCampus",
                                // component: AddCampus,
                                rights: "Campus.add",
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/master/edit-campus",
                                name: "Edit Campus",
                                title: "Edit Campus",
                                key: "editCampus",
                                // component: AddCampus,
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/master/all-campus",
                                name: "All Campuses",
                                title: "All Campuses",
                                key: "allCampus",
                                // component: AllCampus,
                                rights: "Campus.view",
                            },
                            {
                                path: "/master/consortiums",
                                name: "Consortiums",
                                title: "Consortiums",
                                key: "allConsortiums",
                                // component: AllConsortiums,
                                rights: "Consortiums.view",
                            },
                            {
                                path: "/master/university-partnership",
                                name: "University Partnership",
                                title: "University Partnership",
                                key: "allConsortiums",
                                // component: UniversityPartnership,
                                rights: "UniversityPartnership.view"
                            },

                        ],
                    },
                    {
                        path: '/courses',
                        name: 'Courses',
                        key: 'courses',
                        title: 'Courses',
                        children: [
                            {
                                path: "/master/add-course",
                                name: "Add Course ",
                                title: "Add Course",
                                key: "addCourse",
                                // component: AddCourse,
                                rights: "Course.add",
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/master/edit-course",
                                name: "Edit Course",
                                title: "Edit Course",
                                key: "editCourse",
                                // component: AddCourse,
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/master/all-course",
                                name: "All Courses",
                                title: "All Courses",
                                key: "allCourse",
                                rights: "Course.view",
                                // component: AllCourse,
                            },
                            {
                                path: "/master/add-faculty",
                                name: "Add Faculty ",
                                title: "Add Faculty",
                                key: "addFaculty",
                                // component: AddFaculty,
                                rights: "Faculty.add",
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/master/all-faculties",
                                name: "All Faculties",
                                title: "All Faculties",
                                // component: AllFaculty,
                                rights: "Faculty.view",
                            },
                            {
                                path: "/master/edit-faculty",
                                name: "Edit Faculty",
                                title: "Edit Faculty",
                                key: "editFaculty",
                                // component: AddFaculty,
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/master/add-level",
                                name: "Add Level ",
                                title: "Add Level",
                                key: "addLevel",
                                // component: AddLevel,
                                rights: "Level.add",
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/master/all-level",
                                name: "All Levels",
                                title: "All Levels",
                                // component: AllLevel,
                                rights: "Level.view",
                            },
                            {
                                path: "/master/edit-level",
                                name: "Edit Level",
                                title: "Edit Level",
                                key: "editLevel",
                                // component: AddLevel,
                                dontShowOnMenu: true,
                            },
                        ]
                    },

                    {
                        path: "/board",
                        name: "Origin Institutions",
                        key: "Origin Institutions",
                        authority: ["admin", "user"],
                        children: [
                            {
                                path: "/board/all-board",
                                name: "List",
                                title: "List",
                                // component: AllBoard,
                                rights: "Boards.view",
                            },
                            {
                                path: '/degrees',
                                name: 'Type Of Degrees',
                                title: 'Type of Degrees',
                                // component: typeOfDegree,
                                rights: "typeOfDegree.view"
                            },
                            {
                                path: "/board/add-board",
                                name: "Add",
                                title: "Add",
                                key: "addBoard",
                                // component: AddBoard,
                                rights: "Boards.add",
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/board/edit-board",
                                name: "Edit",
                                title: "Edit",
                                key: "editBoard",
                                // component: AddBoard,
                                dontShowOnMenu: true,
                            },

                            {
                                path: "/board/boardRankings",
                                name: "Rankings",
                                title: "Rankings",
                                key: "boardRankings",
                                // component: AllBoardRankings,
                                rights: "BoardRankings.view",
                            },
                            {
                                path: "/board/boardCategories",
                                name: "Categories",
                                title: "Categories",
                                key: "boardCategories",
                                // component: AllBoardCategories,
                                rights: "BoardCategories.view",
                            },
                            {
                                path: '/qualification-scores',
                                name: 'Qualification Scores',
                                title: 'Qualification Scores',
                                // component: qualificationScores,
                                rights: 'qualificationScores.view'
                            },
                            {
                                path: "/master/all-restricted-local-universities",
                                name: "Restricted Local Universities",
                                title: "Restricted Local     Universities",
                                // component: AllRestrictedUniversities,
                                rights: "RestrictedLocalUniversity.view",
                            },
                            {
                                path: "/master/add-restricted-local-university",
                                name: "Add Restricted Local University",
                                title: "Add Restricted Local University",
                                key: "addRestrictedLocalUniversity",
                                // component: AddRestrictedUniversities,
                                rights: "RestrictedLocalUniversity.add",
                                dontShowOnMenu: true,
                            },
                            {
                                path: "/master/edit-restricted-local-university",
                                name: "Edit Restricted Local University",
                                title: "Edit Restricted Local University",
                                key: "editRestricted Local University",
                                // component: AddRestrictedUniversities,
                                dontShowOnMenu: true,
                            },
                        ]
                    },
                    {
                        path: "/master/add-visa-category",
                        name: "Add Visa Category ",
                        title: "Add Visa Category",
                        key: "addVisaCategory",
                        // component: AddVisaCategory,
                        rights: "Level.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/all-visa-category",
                        name: "All Visa Category",
                        title: "All Visa Category",
                        // component: AllVisaCategory,
                        rights: "Level.view",
                    },
                    {
                        path: "/master/edit-visa-categories",
                        name: "Edit Visa Categories",
                        title: "Edit Visa Categories",
                        key: "editVisaCategories",
                        // component: AddVisaCategory,
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/other/vendors",
                        name: "Forex Vendors",
                        title: "Forex Vendors",
                        key: "AllVendors",
                        // component: AllVendors,
                        rights: "vendors.view",
                    }
                ]
            },
            {
                path: '/sub-management',
                icon: (
                    <i className={"anticon"}>
                        <FaBuilding />
                    </i>
                ),
                name: 'Sub Agent',
                title: "Sub Agent",
                key: "user",
                authority: ["admin", "user"],
                children: [
                    {
                        path: "/master/add-subAgent",
                        name: "Add",
                        title: "Add",
                        key: "addSubAgent",
                        // component: AddSubAgent,
                        rights: "subAgent.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/all-subAgent",
                        name: "Sub Agents",
                        title: "Sub Agents",
                        // component: AllSubAgent,
                        rights: "subAgent.view",
                    },
                    {
                        path: "/master/edit-subAgent",
                        name: "Edit",
                        title: "Edit",
                        key: "editSubAgent",
                        // component: AddSubAgent,
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/sub-agents/plans",
                        name: "Plans",
                        title: "Plans",
                        key: "sub-agents/Plans",
                        // component: SubAgentPlans,
                        rights: "subAgentPlans.view",
                    },
                    {
                        path: "/sub-agents/students",
                        name: "Sub Agent Students",
                        title: "Sub Agent Students",
                        key: "sub-agents/students",
                        // component: SubAgentStudents,
                        rights: "subAgentStudents.view",
                    },
                ]
            },
            {
                path: "/task",
                name: "Task",
                key: "task",
                icon: (
                    <i className={"anticon"}>
                        <FaClipboardList />
                    </i>
                ),
                title: "Task",
                // component: FullCalendarTaskManagement,
                authority: ["admin", "user"],
                rights: "Task.view",
                subRights: ["Task.view"],
            },
            {
                path: "/telecaller",
                name: "Telecaller",
                icon: (
                    <i className={"anticon"}>
                        <FaHeadphones />
                    </i>
                ),
                key: "addTelecaller",
                title: "Telecaller",
                // component: Telecaller,
                rights: "TelecallerManagement.add",
                subRights: ["TelecallerManagement.add"],
            },
            {
                path: "/user",
                icon: (
                    <i className={"anticon"}>
                        <FaUsers />
                    </i>
                ),
                name: "User",
                title: "User",
                key: "user",
                authority: ["admin", "user"],
                subRights: ["UserManagement.view", "Contact.view"],
                children: [
                    {
                        path: "/users",
                        name: "Users",
                        title: "Users",
                        // component: UserManagement,
                        rights: "UserManagement.view",
                    },
                    {
                        path: "/user/edit-user",
                        name: "User ",
                        title: "User",
                        key: "editUser",
                        dontShowOnMenu: true,
                        // component: UserManagement,
                        rights: "UserManagement.view",
                    },
                    {
                        path: "/group",
                        name: "Roles and Permissions",
                        key: "addGroup",
                        title: "Roles and Permissions",
                        // component: AddGroup,
                        rights: "UserManagement.view",
                    },
                    {
                        path: "/group/:id",
                        name: "Group",
                        key: "editGroup",
                        title: "Group",
                        // component: AddGroup,
                        dontShowOnMenu: true,
                        rights: "UserManagement.view",
                    }
                ],
            },
        ]
    },
    // Appointments
    {
        path: "/appointment",
        name: "Appointments",
        key: "appointments",
        title: "Appointments",
        icon: (
            <i className={"anticon"}>
                <FaCalendarAlt />
            </i>
        ),
        component: Appointment,
        subRights: [],
        authority: ["admin", "user"],
    },


    // Course Finder
    {
        path: "/course-filtering",
        name: "Course Finder",
        title: "Course Finder",
        key: "course-filtering",
        icon: (
            <i className={"anticon"}>
                <FaUserGraduate />
            </i>
        ),
        component: CourseFiltering,
        rights: "CourseFinder.view",
        subRights: [],
        authority: ["admin", "user"],
    },

    // Desks
    {

        path: "/desk",
        name: "Desks",
        key: "desk",
        icon: (
            <i className={"anticon"}>
                <FaPhabricator />
            </i>
        ),
        authority: ["admin", "user"],
        subRights: [
            "OperationManagerDesk.view",
            "CounsellingDesk.view",
            "RegistrationDesk.view",
            "SubmitFees.view",
            "AccountPayments.view",
            "ApplicationDesk.view",
            "VisaDesk.view",
            "ClaimDesk.view",
            "financeClaims.view",
            "ArchiveDesk.view",
            "PaymentDesk.view",
            "DeadInquiry.view",
        ],
        children: [
            {
                path: "/desk/operation-manager-desk",
                name: "Operation Manager",
                title: "Operation Manager",
                key: "OperationManager",
                component: OperationManagerDesk,
                rights: "OperationManagerDesk.view",
            },
            {
                path: "/operation-manager-inquiry/update",
                name: "update operation manager Lead",
                title: "update operation manager Lead",
                key: "edit1",
                component: EditOperationManagerDesk,
                dontShowOnMenu: true,
            },
            {
                path: "/desk/all-desk",
                name: "Counselling",
                title: "Counselling",
                key: "counselling",
                component: CounsellingDesk,
                rights: "CounsellingDesk.view",
            },
            {
                path: "/desk/allRegistration-desk",
                name: "Registration",
                title: "Registration",
                key: "registration",
                children: [
                    {
                        path: "/desk/allRegistration-desk",
                        name: "Registration",
                        title: "Registration",
                        key: "registration",
                        component: RegistrationDesk,
                        rights: "RegistrationDesk.view",
                    },
                    {
                        path: "/desk/submit-fees",
                        name: "Submit Fees",
                        title: "Submit Fees",
                        key: "submitFees",
                        component: SubmitFees,
                        rights: "SubmitFees.view",
                    },
                    {
                        path: "/desk/account-payments",
                        name: "Account Payments",
                        title: "Account Payments",
                        key: "account-payments",
                        component: AllAccountPayments,
                        rights: "AccountPayments.view",
                    },
                ],
            },
            {
                path: "/desk/allApplication-desk",
                name: "Application",
                title: "Application",
                component: ApplicationDesk,
                key: "application",
                rights: "ApplicationDesk.view",
            },
            {
                path: "/desk/allVisa-desk",
                name: "Visa Desk",
                title: "Visa Desk",
                key: "visa",
                component: VisaDesk,
                rights: "VisaDesk.view",
            },
            {
                path: "/desk/allApplication-desk/enrollment",
                name: "Enrollment List",
                title: "Enrollment Details",
                component: Enrollment,
                key: "enrollment",
                dontShowOnMenu: true,
            },
            {
                path: "/desk/allClaim-desk",
                name: "Claim Desk",
                title: "Claim Desk",
                key: "claim",
                children: [
                    {
                        path: "/desk/allClaim-desk",
                        name: "Claim Desk",
                        title: "Claim Desk",
                        key: "claim",
                        component: ClaimDesk,
                        rights: "ClaimDesk.view",
                    },
                    {
                        path: "/desk/finance-claims",
                        name: "Student Record Sheet",
                        title: 'Student Record Sheet',
                        key: "finance-claims",
                        component: AllFinanceClaim,
                        rights: "financeClaims.view"
                    }
                ]
            },
            {
                path: "/desk/allArchive-desk",
                name: "Archive Desk",
                title: "Archive Desk",
                component: ArchiveDesk,
                key: "archive",
                rights: "ArchiveDesk.view",
            },
            {
                path: "/desk/invoice",
                name: "Invoices To Be Generated",
                title: "Invoices To Be Generated",
                component: InvoiceGenerated,
                key: "invoiceGenerated",
                rights: "ClaimDesk.view",
                viewByBranch: "ClaimDesk.viewByBranch",
                dontShowOnMenu: true,
            },
            {
                path: "/desk/dueInvoice",
                name: "Invoices List",
                title: "Invoices List",
                component: DueInvoices,
                key: "dueInvoices",
                rights: "ClaimDesk.view",
                dontShowOnMenu: true,
            },
            {
                path: "/desk/branchInvoice",
                name: "Branch/Partner Due Invoices",
                title: "Branch/Partner Due Invoices",
                component: BranchInvoices,
                key: "branchInvoices",
                rights: "ClaimDesk.view",
                dontShowOnMenu: true,
            },
            {
                path: "/desk/generateInvoice",
                name: "Generate Invoice",
                title: "Generate Invoice",
                key: "generateInvoice",
                component: GenerateInvoice,
                dontShowOnMenu: true,
                //  rights: 'ClaimDesk.view'
            },
            {
                path: "/desk/generateInvoice/update",
                name: "Update Invoice",
                title: "Update Invoice",
                key: "updateGenerateInvoice",
                component: UpdateGenerateInvoice,
                dontShowOnMenu: true,
                //  rights: 'ClaimDesk.view'
            },
            {
                path: "/desk/branchInvoice/update",
                name: "Update Branch Invoice",
                title: "Update Branch Invoice",
                key: "updateBranchInvoice",
                component: EditBranchInvoice,
                dontShowOnMenu: true,
                //  rights: 'ClaimDesk.view'
            },
            {
                path: "/desk/allDeadStudent-list",
                name: "Dead Inquiry",
                title: "Dead Inquiry",
                component: DeadStudent,
                rights: "DeadInquiry.view",
            },
            {
                path: "/desk/dead-counselling-desk",
                name: "Dead Counselling",
                title: "Dead Counselling",
                key: "dead-counselling-desk",
                component: DeadCounsellingDesk,
                rights: "DeadCounsellingDesk.view",
            },
        ],
    },
    {
        path: '/inquiry',
        name: 'Students',
        icon: (
            <i className={"anticon"}>
                <FaVectorSquare />
            </i>
        ),
        key: 'inquiry',
        authority: ["admin", "user"],
        subRights: [
            "Student.view",
            "myStudents.view",
        ],
        children: [
            {
                path: "/allStudents",
                name: "List",
                title: "List",
                key: "allStudents",
                component: AllStudents,
                authority: ["admin", "user"],
                rights: "Student.view",
            },
            {
                path: "/inquiry/myStudents",
                name: "My Students",
                title: "My Students",
                key: 'myStudents',
                // component: MyStudents,
                rights: 'myStudents.view',
            },
        ]
    },
    // Lead Management 
    {
        path: "/inquiry",
        name: "Lead Management",
        icon: (
            <i className={"anticon"}>
                <FaVectorSquare />
            </i>
        ),
        key: "inquiry",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        subRights: [
            "Student.view",
            "AssignedLeads.view",
            "rawInquiry.view",
            "VisaEnquiry.view",
            "SocialFacebook.view",
            "SocialGoogle.view",
            "SocialSetting.view",
            "CourseFinder.view",
            "TransferCounsellor.view",
            "UploadDocuments.view",
            "myStudents.view"
        ],
        children: [
            {
                path: '/student-list',
                name: 'Student List',
                title: 'Student List',
                key: 'student-list',
                component: StudentList,
                rights: 'studentList.view',
            },
            {
                path: "/inquiry/myStudents",
                name: "My Students",
                title: "My Students",
                key: 'myStudents',
                component: MyStudents,
                rights: 'myStudents.view',
            },
            {
                path: "/allStudents",
                name: "Students",
                title: "Students",
                rights: "Student.view",
                children: [
                    {
                        path: "/allLeads",
                        name: 'Leads',
                        title: 'Leads',
                        key: 'leads',
                        component: AllStudents,
                        authority: ["admin", "user"],
                        rights: "Student.view",
                    },
                    {
                        path: "/allStudents",
                        name: "List",
                        title: "List",
                        key: "allStudents",
                        // component: AllStudents,
                        authority: ["admin", "user"],
                        rights: "Student.view",
                    },
                    {
                        path: "/inquiry/add",
                        key: "studentadd",
                        name: "Add",
                        title: "Add",
                        component: AddInquiry,
                        rights: "Student.add",
                    }
                ]
            },
            {
                path: "/raw/inquiry/all",
                name: "Raw Inquiry",
                title: "Raw Inquiry",
                rights: "rawInquiry.view",
                children: [
                    // {
                    //     path: "/raw/inquiry/all",
                    //     name: "List",
                    //     title: "List",
                    //     rights: "rawInquiry.view",
                    //     component: AllRawInquiry,
                    // },
                    {
                        path: "/raw/inquiry/all",
                        name: "List",
                        title: "List",
                        rights: "rawInquiry.view",
                        component: RawInquiryList,
                    },
                    {
                        path: "/raw/inquiry/add",
                        name: "Add",
                        title: "Add",
                        rights: "rawInquiry.add",
                        component: AddRawInquiry
                    },
                    {
                        path: "/rawInquiry/edit-rawInquiry",
                        name: "Raw Inquiry",
                        title: "Raw Inquiry",
                        key: "editRawInquiry",
                        dontShowOnMenu: true,
                        component: AddRawInquiry,
                    }
                ]
            },
            {
                path: "/visaEnquiry/all",
                name: "Visitor Visa Enquiry",
                title: "Visitor Visa Enquiry",
                rights: "VisaEnquiry.view",
                children: [
                    {
                        path: "/visaEnquiry/all",
                        name: "List",
                        title: "List",
                        component: AllVisaEnquiry,
                        rights: "VisaEnquiry.view",
                    },
                    // {
                    //     path: "/visaEnquiry/approved",
                    //     name: "Approved",
                    //     title: "Approved",
                    //     component: AllVisaEnquiry,
                    //     rights: "VisaEnquiry.view",
                    // },
                    // {
                    //     path: "/visaEnquiry/dead",
                    //     name: "Dead",
                    //     title: "Dead",
                    //     component: AllVisaEnquiry,
                    //     rights: "VisaEnquiry.view",
                    // },
                    {
                        path: "/visaEnquiry/add",
                        name: "Add",
                        title: "Add",
                        component: AddVisaEnquiry,
                        rights: "VisaEnquiry.add",
                    },
                    {
                        path: "/visaEnquiry/edit-visaEnquiry",
                        name: "Visa Enquiry ",
                        title: "Visa Enquiry",
                        key: "editVisaEnquiry",
                        dontShowOnMenu: true,
                        component: AddVisaEnquiry,
                        rights: "VisaEnquiry.edit",
                    },
                    {
                        path: "/visaEnquiry/type",
                        name: "Type",
                        title: "Type",
                        component: VisaInquiryType,
                    }
                ]
            },

            {
                path: '/lead-settings',
                name: 'Lead Settings',
                key: 'lead-settings',
                title: 'Lead Settings',
                subRights: [
                    "ratings.view",
                    "source.view",
                    "GenderDetails.view",
                    "MaritalStatus.view",
                    "followUpTypes.view",
                    "testTypes.view",
                    "documentTypes.view",
                    "leadSettings.view",
                ],
                children: [
                    {
                        path: "/other/ratings",
                        name: "Ratings",
                        title: "Ratings",
                        key: "allRatings",
                        component: AllRatings,
                        rights: "ratings.view",
                    },
                    {
                        path: "/other/sub-ratings",
                        name: "Rating Tags",
                        title: "Rating Tags",
                        key: "allSubRatings",
                        component: allSubRatings,
                        rights: "ratings.view",
                    },
                    {
                        path: "/other/source",
                        name: "Source",
                        title: "Source",
                        key: "allSource",
                        component: allSource,
                        rights: "source.view",
                    },
                    {
                        path: "/other/genders",
                        name: "Genders",
                        title: "Genders",
                        key: "genders",
                        component: AllGenders,
                        rights: "GenderDetails.view",
                    },
                    {
                        path: "/other/marital-status",
                        name: "Marital Status",
                        title: "Marital Status",
                        key: "maritalStatus",
                        component: AllMaritalStatus,
                        rights: "MaritalStatus.view",
                    },
                    {
                        path: "/other/followup-types",
                        name: "Follow-up Tags",
                        title: "Follow-up Tags",
                        key: "followupTypes",
                        component: AllFollowupTypes,
                        rights: "followUpTypes.view",
                    },
                    {
                        path: "/other/lead-status",
                        name: "Lead Status",
                        title: "Lead Status",
                        key: "leadStatus",
                        component: LeadStatus,
                        rights: "leadStatus.view",
                    },
                    {
                        path: "/other/test-types",
                        name: "Test Types",
                        title: "Test Types",
                        key: "testTypes",
                        component: AllTestTypes,
                        rights: "testTypes.view",
                    },
                    {
                        path: "/other/document-types",
                        name: 'Document Types',
                        title: 'Document Types',
                        key: 'documentTypes',
                        component: AllDocumentTypes,
                        rights: "documentTypes.view"
                    },
                    {
                        path: "/other/lead-settings",
                        name: 'Settings',
                        title: 'Settings',
                        key: 'settings',
                        component: leadSettings,
                        rights: "leadSettings.view"
                    }
                ]
            },
            {
                path: "/dropped-leads",
                name: "Dropped Leads",
                key: "dropped-leads",
                title: "Dropped Leads",
                authority: ["admin", "user"],
                component: DroppedLeads,
                rights: "showDropLead.view",
            },
            {
                path: "/lead-transfer",
                name: "Lead Transfer",
                key: "lead-transfer",
                title: "Lead Transfer",
                authority: ["admin", "user"],
                component: TransferCounsellor,
                rights: "TransferCounsellor.view",
            },
            {
                path: "/assigned-leads",
                name: "Assigned Leads",
                key: "assigned-leads",
                title: "Assigned Leads",
                authority: ["admin", "user"],
                component: AllAssignedLeads,
                rights: "AssignedLeads.view",
            },
            {
                path: '/lead-referrals',
                name: "Referrals",
                title: "Referrals",
                key: 'referrals',
                component: AllReferrals
            },
            {
                path: "/upload-documents",
                name: "Upload Documents",
                title: "Upload Documents",
                key: "upload-documents",
                component: UploadDocuments,
                rights: "UploadDocuments.view",
            }
        ],
    },

    // Follow Ups
    {
        path: "/followUp",
        icon: (
            <i className={"anticon"}>
                <FaPhoneVolume />
            </i>
        ),
        name: "Follow Up Management",
        key: "followUp",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        subRights: ["VisaFollowUps.view", "FollowUps.view"],
        children: [
            {
                path: '/followUp/student-followUp',
                name: 'Student FollowUps',
                title: 'Student FollowUps',
                rights: "FollowUps.view",
                component: AllFollowUp,
            },
            {
                path: '/followUp/visa-followUp',
                name: 'Visitor Visa FollowUps',
                title: 'Visitor Visa FollowUps',
                rights: "VisaFollowUps.view",
                component: VisitorVisaFollowUp
            },
            {
                path: '/followUp/business-proposal-followUp',
                name: 'Business Proposal FollowUps',
                title: 'Business Proposal FollowUps',
                rights: "BusinessProposalsFollowUps.view",
                component: BusinessProposalFollowUps
            },
            {
                path: '/followUp/university-agreement-followUp',
                name: 'University Agreement FollowUps',
                title: 'University Agreement FollowUps',
                rights: 'universityAgreementFollowUps.view',
                component: UniversityAgreementFollowUps
            },
            {
                path: '/followUp/raw-inquiry-followUp',
                name: 'Raw Inquiry FollowUps',
                title: 'Raw Inquiry FollowUps',
                rights: 'rawInquiryFollowUps.view',
                component: RawInquiryFollowUps
            },
            {
                path: '/followUp/postpone-requests',
                name: 'PostPone Requests',
                title: 'Postpone Requests',
                rights: 'followUpPostponeRequest.view',
                component: FollowUpPostponeRequest,
            }
        ]
    },

    // Follow Ups 
    // {
    //     path: "/followUp/all-followUp",
    //     name: "Follow Up Management",
    //     title: "Follow Up Management",
    //     icon: (
    //         <i className={"anticon"}>
    //             <FaPhoneVolume />
    //         </i>
    //     ),
    //     key: "followUp",
    //     authority: ["admin", "user"],
    //     rights: "FollowUps.view",
    //     component: AllFollowUp,
    // },  
    // TelleCaller Management
    {
        path: "/telecaller",
        name: "Telecaller Management",
        icon: (
            <i className={"anticon"}>
                <FaHeadphones />
            </i>
        ),
        key: "addTelecaller",
        title: "Telecaller",
        component: Telecaller,
        dontShowOnMenu: true,
        rights: "TelecallerManagement.add",
        subRights: ["TelecallerManagement.add"],
    },
    // Master Management
    {
        path: "/master",
        icon: "database",
        name: "Master Management",
        key: "mastersManagement",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        subRights: [
            "Country.view",
            "State.view",
            "City.view",
            "vendors.view",
            "ratings.view",
            "source.view",
            "status.view",
            "GenderDetails.view",
            "MaritalStatus.view",
            "University.view",
            "Campus.view",
            "ChannelPartner.view",
            "Course.view",
            "Faculty.view",
            "Level.view",
            "Consortiums.view",
            "RestrictedLocations.view",
            "RestrictedLocalUniversity.view",
            "Boards.add",
            "BoardRankings.view",
            "BoardCategories.view",
            "AgreementManagement.view",
            "followUpTypes.view"
        ],
        children: [
            {
                path: '/location',
                name: 'Locations',
                key: 'locations',
                authority: ["admin", "user"],
                children: [
                    {
                        path: "/location/all-country",
                        name: "All Countries",
                        title: "All Countries",
                        component: AllCountry,
                        rights: "Country.view",
                    },
                    {
                        path: "/location/add-country",
                        name: "Add Country",
                        key: "addCountry",
                        title: "Add Country",
                        component: AddCountry,
                        rights: "Country.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/location/countryFactSheet",
                        name: "Country Fact Sheet",
                        key: "countryFactSheet",
                        title: "Country Fact Sheet",
                        component: CountryFact,
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/location/edit-country",
                        name: "Edit Country",
                        title: "Edit Country",
                        key: "editCountry",
                        component: AddCountry,
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/location/process-country",
                        name: "Process Country",
                        title: "Process Country",
                        key: "processCountry",
                        component: ProcessCountry,
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/location/all-states",
                        name: "All States",
                        title: "All States",
                        component: AllStates,
                        rights: "State.view",
                    },
                    {
                        path: "/location/all-cities",
                        name: "All Cities",
                        title: "All Cities",
                        component: AllCities,
                        rights: "City.view",
                    },
                    {
                        path: "/master/all-restricted-locations",
                        name: "Restricted Locations",
                        title: "Restricted Locations",
                        component: AllRestrictedLocations,
                        rights: "RestrictedLocations.view",
                    },
                    {
                        path: "/master/add-restricted-location",
                        name: "Add Restricted Location ",
                        title: "Add Restricted Location",
                        key: "addRestrictedLocation",
                        component: AddRestrictedLocations,
                        rights: "RestrictedLocations.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/edit-restricted-location",
                        name: "Edit Restricted Location",
                        title: "Edit Restricted Location",
                        key: "editRestrictedLocation",
                        component: AddRestrictedLocations,
                        dontShowOnMenu: true,
                    },
                ]
            },
            {
                path: "/master",
                name: "Institutions",
                key: "masters",
                authority: ["admin", "user"],
                children: [
                    {
                        path: "/master/add-university",
                        name: "Add University",
                        title: "Add University",
                        component: AddUniversity,
                        rights: "University.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/all-universities",
                        name: "All Universities",
                        title: "All Universities",
                        rights: "University.view",
                        component: AllUniversities,
                    },
                    {
                        path: "/master/edit-university",
                        name: "Edit University",
                        title: "Edit University",
                        key: "editUniversity",
                        component: AddUniversity,
                        dontShowOnMenu: true,
                    },
                    {
                        path: '/master/merge-university',
                        name: 'Merge Universities',
                        title: 'Merge Universities',
                        component: MergeUniversity,
                        rights: 'mergeUniversity.view'
                    },
                    {
                        path: "/master/add-campus",
                        name: "Add Campus",
                        title: "Add Campus",
                        key: "addCampus",
                        component: AddCampus,
                        rights: "Campus.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/edit-campus",
                        name: "Edit Campus",
                        title: "Edit Campus",
                        key: "editCampus",
                        component: AddCampus,
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/all-campus",
                        name: "All Campuses",
                        title: "All Campuses",
                        key: "allCampus",
                        component: AllCampus,
                        rights: "Campus.view",
                    },
                    {
                        path: "/master/consortiums",
                        name: "Consortiums",
                        title: "Consortiums",
                        key: "allConsortiums",
                        component: AllConsortiums,
                        rights: "Consortiums.view",
                    },
                    {
                        path: "/master/university-partnership",
                        name: "University Partnership",
                        title: "University Partnership",
                        key: "allConsortiums",
                        component: UniversityPartnership,
                        rights: "UniversityPartnership.view"
                    },

                ],
            },
            {
                path: '/courses',
                name: 'Courses',
                key: 'courses',
                title: 'Courses',
                children: [
                    {
                        path: "/master/add-course",
                        name: "Add Course ",
                        title: "Add Course",
                        key: "addCourse",
                        component: AddCourse,
                        rights: "Course.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/edit-course",
                        name: "Edit Course",
                        title: "Edit Course",
                        key: "editCourse",
                        component: AddCourse,
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/all-course",
                        name: "All Courses",
                        title: "All Courses",
                        key: "allCourse",
                        rights: "Course.view",
                        component: AllCourse,
                    },
                    {
                        path: "/master/add-faculty",
                        name: "Add Faculty ",
                        title: "Add Faculty",
                        key: "addFaculty",
                        component: AddFaculty,
                        rights: "Faculty.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/all-faculties",
                        name: "All Faculties",
                        title: "All Faculties",
                        component: AllFaculty,
                        rights: "Faculty.view",
                    },
                    {
                        path: "/master/edit-faculty",
                        name: "Edit Faculty",
                        title: "Edit Faculty",
                        key: "editFaculty",
                        component: AddFaculty,
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/add-level",
                        name: "Add Level ",
                        title: "Add Level",
                        key: "addLevel",
                        component: AddLevel,
                        rights: "Level.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/all-level",
                        name: "All Levels",
                        title: "All Levels",
                        component: AllLevel,
                        rights: "Level.view",
                    },
                    {
                        path: "/master/edit-level",
                        name: "Edit Level",
                        title: "Edit Level",
                        key: "editLevel",
                        component: AddLevel,
                        dontShowOnMenu: true,
                    },
                ]
            },

            {
                path: "/board",
                name: "Origin Institutions",
                key: "Origin Institutions",
                authority: ["admin", "user"],
                children: [
                    {
                        path: "/board/all-board",
                        name: "List",
                        title: "List",
                        component: AllBoard,
                        rights: "Boards.view",
                    },
                    {
                        path: '/degrees',
                        name: 'Type Of Degrees',
                        title: 'Type of Degrees',
                        component: typeOfDegree,
                        rights: "typeOfDegree.view"
                    },
                    {
                        path: "/board/add-board",
                        name: "Add",
                        title: "Add",
                        key: "addBoard",
                        component: AddBoard,
                        rights: "Boards.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/board/edit-board",
                        name: "Edit",
                        title: "Edit",
                        key: "editBoard",
                        component: AddBoard,
                        dontShowOnMenu: true,
                    },

                    {
                        path: "/board/boardRankings",
                        name: "Rankings",
                        title: "Rankings",
                        key: "boardRankings",
                        component: AllBoardRankings,
                        rights: "BoardRankings.view",
                    },
                    {
                        path: "/board/boardCategories",
                        name: "Categories",
                        title: "Categories",
                        key: "boardCategories",
                        component: AllBoardCategories,
                        rights: "BoardCategories.view",
                    },
                    {
                        path: '/qualification-scores',
                        name: 'Qualification Scores',
                        title: 'Qualification Scores',
                        component: qualificationScores,
                        rights: 'qualificationScores.view'
                    },
                    {
                        path: "/master/all-restricted-local-universities",
                        name: "Restricted Local Universities",
                        title: "Restricted Local     Universities",
                        component: AllRestrictedUniversities,
                        rights: "RestrictedLocalUniversity.view",
                    },
                    {
                        path: "/master/add-restricted-local-university",
                        name: "Add Restricted Local University",
                        title: "Add Restricted Local University",
                        key: "addRestrictedLocalUniversity",
                        component: AddRestrictedUniversities,
                        rights: "RestrictedLocalUniversity.add",
                        dontShowOnMenu: true,
                    },
                    {
                        path: "/master/edit-restricted-local-university",
                        name: "Edit Restricted Local University",
                        title: "Edit Restricted Local University",
                        key: "editRestricted Local University",
                        component: AddRestrictedUniversities,
                        dontShowOnMenu: true,
                    },
                ]
            },
            {
                path: "/master/add-visa-category",
                name: "Add Visa Category ",
                title: "Add Visa Category",
                key: "addVisaCategory",
                component: AddVisaCategory,
                rights: "Level.add",
                dontShowOnMenu: true,
            },
            {
                path: "/master/all-visa-category",
                name: "All Visa Category",
                title: "All Visa Category",
                component: AllVisaCategory,
                rights: "Level.view",
            },
            {
                path: "/master/edit-visa-categories",
                name: "Edit Visa Categories",
                title: "Edit Visa Categories",
                key: "editVisaCategories",
                component: AddVisaCategory,
                dontShowOnMenu: true,
            },
            {
                path: "/other/vendors",
                name: "Forex Vendors",
                title: "Forex Vendors",
                key: "AllVendors",
                component: AllVendors,
                rights: "vendors.view",
            }
        ]
    },
    // User Management  
    {
        path: "/user",
        icon: (
            <i className={"anticon"}>
                <FaUsers />
            </i>
        ),
        name: "User Management",
        title: "User Management",
        key: "user",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        subRights: ["UserManagement.view", "Contact.view"],
        children: [
            {
                path: "/users",
                name: "Users",
                title: "Users",
                component: UserManagement,
                rights: "UserManagement.view",
            },
            {
                path: "/user/edit-user",
                name: "User ",
                title: "User",
                key: "editUser",
                dontShowOnMenu: true,
                component: UserManagement,
                rights: "UserManagement.view",
            },
            {
                path: "/group",
                name: "Roles and Permissions",
                key: "addGroup",
                title: "Roles and Permissions",
                component: AddGroup,
                rights: "UserManagement.view",
            },
            {
                path: "/group/:id",
                name: "Group",
                key: "editGroup",
                title: "Group",
                component: AddGroup,
                dontShowOnMenu: true,
                rights: "UserManagement.view",
            }
        ],
    },
    // Branch Management
    {
        path: "/all-branch",
        icon: (
            <i className={"anticon"}>
                <FaCity />
            </i>
        ),
        name: "Branch Management",
        title: "Branch Management",
        key: "user",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        subRights: ["plans.view", "Branch.view"],
        children: [
            {
                path: "/master/add-branch",
                name: "Add",
                title: "Add",
                key: "addBranch",
                component: AddBranch,
                rights: "Branch.add",
                dontShowOnMenu: true,
            },
            {
                path: "/master/update-branch",
                name: "Update Branch",
                title: "Update Branch",
                key: "updateBranch",
                component: UpdateBranch,
                // rights: "Branch.add",
                dontShowOnMenu: true,
            },
            {
                path: "/master/all-branch",
                name: "Branches",
                title: "Branches",
                component: AllBranch,
                rights: "Branch.view",
            },
            {
                path: "/master/edit-branch",
                name: "Edit",
                title: "Edit",
                key: "editBranch",
                component: AddBranch,
                dontShowOnMenu: true,
            },
            {
                path: "/branch/plans",
                name: "Plans",
                title: "Plans",
                key: "branchPlans",
                component: AllPlans,
                rights: "plans.view",
            },
        ]
    },

    // Sub Agent Management
    {
        path: '/sub-management',
        icon: (
            <i className={"anticon"}>
                <FaBuilding />
            </i>
        ),
        name: 'Sub Agent Management',
        title: "Sub Agent Management",
        dontShowOnMenu: true,
        key: "user",
        authority: ["admin", "user"],
        children: [
            {
                path: "/master/add-subAgent",
                name: "Add",
                title: "Add",
                key: "addSubAgent",
                component: AddSubAgent,
                rights: "subAgent.add",
                dontShowOnMenu: true,
            },
            {
                path: "/master/all-subAgent",
                name: "Sub Agents",
                title: "Sub Agents",
                component: AllSubAgent,
                rights: "subAgent.view",
            },
            {
                path: "/master/edit-subAgent",
                name: "Edit",
                title: "Edit",
                key: "editSubAgent",
                component: AddSubAgent,
                dontShowOnMenu: true,
            },
            {
                path: "/sub-agents/plans",
                name: "Plans",
                title: "Plans",
                key: "sub-agents/Plans",
                component: SubAgentPlans,
                rights: "subAgentPlans.view",
            },
            {
                path: "/sub-agents/students",
                name: "Sub Agent Students",
                title: "Sub Agent Students",
                key: "sub-agents/students",
                component: SubAgentStudents,
                rights: "subAgentStudents.view",
            },
        ]
    },
    // Channel Partner Management
    {
        path: "/add-partner",
        icon: (
            <i className={"anticon"}>
                <FaUsers />
            </i>
        ),
        name: "Channel Partner Management",
        title: "Channel Partner Management",
        key: "user",
        authority: ["admin", "user"],
        subRights: ["ChannelPartner.view"],
        dontShowOnMenu: true,
        children: [
            {
                path: "/master/add-partner",
                name: "Add Channel Partner",
                title: "Add Channel Partner",
                key: "addPartner",
                component: AddPartner,
                rights: "ChannelPartner.add",
                dontShowOnMenu: true,
            },
            {
                path: "/master/edit-partner",
                name: "Edit Channel Partner",
                title: "Edit Channel Partner",
                key: "editPartner",
                component: AddPartner,
                dontShowOnMenu: true,
            },
            {
                path: "/master/all-partner",
                name: "List",
                title: "List",
                component: AllPartner,
                rights: "ChannelPartner.view",
            }
        ]
    },
    // Employee Management
    {
        path: "/updateProfile",
        icon: (
            <i className={"anticon"}>
                <FaUserEdit />
            </i>
        ),
        name: "Employee Management",
        title: "Employee Management",
        key: "profile-management",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        subRights: [],
        children: [
            {
                path: "/updateProfile",
                name: "Update Profile",
                title: "Update Profile",
                key: "updateProfile",
                component: UpdateProfile
            },
            {
                path: "/changePassword",
                name: "Change Password",
                title: "Change Password",
                key: "changePassword",
                component: ChangePassword
            },
            {
                path: "/leave-applications",
                name: "Leave Applications",
                title: "Leave Applications",
                component: LeaveApplication,
            },
            {
                path: "/resignation",
                name: "Resignation",
                title: "Resignation",
                component: Resignation
            },
            {
                path: "/salary-slip",
                name: "Request Salary Slip",
                title: "Request Salary Slip",
                component: SalarySlip
            },
            {
                path: "/team-leaves",
                name: "Team Leaves",
                title: "Team Leaves",
                component: TeamLeaves,
                dontShowOnMenu: (localUser && localUser.isHOD ? false : true)
            },
            {
                path: "/team-appraisals",
                name: "Team Appraisals",
                title: "Team Appraisals",
                component: TeamAppraisals,
                dontShowOnMenu: (localUser && localUser.isHOD ? false : true)
            },
            {
                path: "/login-history",
                name: "Login History",
                key: "login-history",
                title: 'Login History',
                component: AllUserLoginHistory,
                rights: "userLoginHistory.view",
            },
            {
                path: '/view-annoucements',
                name: 'View Annoucements',
                key: 'view-announcements',
                title: 'View Annoucements',
                component: ViewAnnoucement
            },
            {
                path: '/appraisal-requests',
                name: 'Appraisal Request',
                key: 'Appraisal Request',
                title: 'Appraisal Request',
                component: AppraisalRequests
            },
            {
                path: '/salary',
                name: 'Review Salary',
                key: 'Salary Details',
                title: 'Review Salary',
                component: UserSalary
            },

            {
                path: '/personal-phones',
                name: 'Employee Phones',
                title: 'Employee Phones',
                component: EmployeesPersonalPhones,
                rights: 'employeesPhones.view'
            },
            {
                path: '/staff-in-out-time',
                name: 'Staff In Out Time',
                title: 'Staff In Out Time',
                component: StaffInOutTime,
                rights: 'staffInOutTime.view'
            },
            {
                path: '/staff-apology',
                name: 'Apology',
                title: 'Apology',
                component: StaffApologies,
                rights: 'apology.view'
            }
        ]
    },
    // Hr Management
    {
        path: "/payroll-management",
        icon: (
            <i className={"anticon"}>
                <FaUserSecret />
            </i>
        ),
        name: "HR Management",
        title: "HR Management",
        key: "payroll-management",
        dontShowOnMenu: true,
        subRights: [
            'allEmployees.view',
            'staffResignation.view',
            "PayrollManagement.view",
            "staffLoginHistory.view",
            "govtHolidays.view",
            "staffSalaryManagement.view",
            "StaffLeaves.view",
            "RegularisationRequests.view",
            "companyAssets.view",
            "jobRoles.view",
            "announcements.view",
            "letterOfIntent.view",
            "payrollDocuments.view",
            "shiftTimings.view",
            "departments.view",
            "IncentiveInvoice.view",
            "IncentiveDesk.view"
        ],
        authority: ["admin", "user"],
        children: [
            {
                path: "/branch-users",
                name: "Employees",
                title: "Employees",
                component: AllEmployees,
                rights: 'allEmployees.view'
            },
            {
                path: "/branch-users/edit-user",
                name: "Edit Employee",
                title: "Edit Employee",
                key: "editUser",
                dontShowOnMenu: true,
                component: AllEmployees,
                rights: 'allEmployees.view'
            },
            {
                path: "/staff-login-history",
                name: "Staff Login History",
                title: "Staff Login History",
                component: AllStaffLoginHistory,
                rights: "staffLoginHistory.view",
            },
            {
                path: "/letter-of-intent",
                name: "Letter of Intent",
                title: "Letter of Intent",
                component: LetterOfIntent,
                rights: 'letterOfIntent.view'
            },
            {
                path: "/staff-requests",
                name: "Staff Requests",
                title: "Staff Requests",
                component: RegularisationRequests,
                rights: "RegularisationRequests.view"
            },
            // {
            //     path: "/staff-leaves",
            //     name: "Staff Leaves",
            //     title: "Staff Leaves",
            //     component: StaffLeaves,
            //     rights:"StaffLeaves.view"
            // },
            // {
            //     path: "/staff-appraisal",
            //     name: "Staff Appraisals",
            //     title: "Staff Appraisals",
            //     component: AppraisalsStaff,
            //     rights:"staffAppraisals.view"
            // },
            {
                path: "/payroll-management",
                name: "Staff Salary",
                title: "Staff Salary",
                component: AllStaffOverallReport,
                rights: "PayrollManagement.view",
            },
            {
                path: "/annoucements",
                name: "Announcements",
                title: "Announcements",
                component: Announcements,
                rights: 'announcements.view'
            },
            // {
            //     path: "/staff-resignations",
            //     name: "Staff Resignations",
            //     title: "Staff Resignations",
            //     component: StaffResignations,
            //     rights:'staffResignation.view'
            // },
            {
                path: "/govt-holidays",
                name: "Holidays",
                title: "Holidays",
                component: AllGovtHolidays,
                rights: "govtHolidays.view",
            },
            {
                path: "/attendance",
                name: "Staff Attendance",
                title: "Staff Attendance",
                component: AbsentStaff,
                rights: 'attendance.view'
            },
            // {
            //     path: "/staff-salaries",
            //     name: "Staff Salaries",
            //     title: "Staff Salaries",
            //     component: StaffSalaries,
            //     right:'staffSalaries.view'
            // },
            {
                path: "/staff-slip-requests",
                name: "Salary Slip Requests",
                title: "Salary Slip Requests",
                component: StaffSalarySlips,
                rights: 'salarySlipRequest.view'
            },
            {
                path: "/payroll-documents",
                name: "Payroll Documents",
                title: "PayrollDocuments",
                component: DocumentTemplates,
                rights: 'payrollDocuments.view'
            },
            // {
            //     path: "/staff-salary-management",
            //     name: "Salary Management",
            //     title: "Salary Management",
            //     component: AllStaffSalaryManagement,
            //     rights: "staffSalaryManagement.view",
            // },
            // {
            //     path:'/support-staff-salary',
            //     name:'Support Staff Salary',
            //     title:'Support Staff Salary',
            //     component:SupportStaffSalary,
            //     rights: "staffSalaryManagement.view",
            // },
            {
                path: '/job-roles',
                name: 'Job Roles',
                title: 'Job Roles',
                component: JobRoles,
                rights: "jobRoles.view",
            },
            {
                path: '/company-assets',
                name: 'Company Assets',
                title: 'Company Assets',
                component: CompanyAssets,
                rights: 'companyAssets.view'
            },
            {
                path: '/payroll-settings',
                name: 'Settings',
                title: 'Settings',
                component: PayrollSettings,
                rights: 'payrollSettings.view'
            },
            {
                path: "/shift-timings",
                name: "Shift Timings",
                title: "Shift Timings",
                component: ShiftTimings,
                right: 'shiftTimings.view'
            },
            {
                path: '/departments',
                name: 'Departments',
                title: 'Departments',
                component: Departments,
                right: 'departments.view'
            },
            {
                path: "/desk/incentive-invoice",
                name: "Incentive Invoice",
                title: "Incentive Invoice",
                component: IncentiveInvoice,
                rights: "IncentiveInvoice.view",
            },
            {
                path: "/desk/incentive",
                name: "Incentive Desk",
                title: "Incentive Desk",
                component: IncentiveDesk,
                key: "incentiveDesk",
                rights: "IncentiveDesk.view",
            },

        ],
    },
    // Agreement Management
    {
        path: "/agreement-management",
        name: "Agreement Management",
        key: "transfer",
        icon: (
            <i className={"anticon"}>
                <FaBookReader />
            </i>
        ),
        title: "Agreement Management",
        authority: ["admin", "user"],
        component: AllAgreementManagement,
        dontShowOnMenu: true,
        rights: "AgreementManagement.view",
        subRights: [],
    },
    {
        path: "/university-business-proposals",
        name: 'University Business Proposals',
        title: 'University Business Proposals',
        authority: ["admin", "user"],
        icon: (
            <i className={"anticon"}>
                <FaBookReader />
            </i>
        ),
        component: BusinessProposals,
        rights: "BusinessProposals.view",
    },
    {
        path: "/trainings",
        name: "Trainings",
        key: "transfer",
        icon: (
            <i className={"anticon"}>
                <GiTeacher />
            </i>
        ),
        title: "Trainings",
        authority: ["admin", "user"],
        component: AllTrainings,
        rights: "trainings.view"
    },


    // Finance Managment
    {
        path: "/finance",
        icon: (
            <i className={"anticon"}>
                <FaHandHoldingUsd />
            </i>
        ),
        name: "Finance Management",
        key: "finance",
        title: "Finance Management",
        authority: ["admin"],
        dontShowOnMenu: true,
        subRights: [
            "finance.view",
            "financeUniversityCommission.view",
            "financeCourseCommission.view",
            "financeTax.view",
            "financeCompanyDetails.view",
            "CommunicationSetting.view",
            "financeInvoiceTo.view",
            "financeClaimDesk.view",
            "financeInvoices.view",
            "financeBranchClaimDesk.view",
            "financeBranchInvoices.view",
            "financeBranchRequests.view",
            "pendingIncentives.view",
        ],
        children: [
            // {
            //     path: "/account-desk",
            //     name: "Generate New Invoices",
            //     title: "Generate New Invoices",
            //     key: "account-desk",
            //     component: AllFinance,
            //     rights: "financeClaimDesk.view",
            //     subRights: ["financeClaimDesk.view"]
            // },
            {
                path: "/finance-desk",
                name: "Final Invoices",
                title: "Final Invoices",
                key: "finance-invoices",
                component: AllInvoices,
                rights: "financeInvoices.view"
            },
            {
                path: "/invoices-desk",
                name: "Bonus/Marketing",
                title: "Bonus/Marketing",
                key: "finance-invoices",
                component: BonusInvoices,
                rights: "financeInvoices.view"
            },
            {
                path: "/finance-desk-performa",
                name: "Performa Invoices",
                title: "Performa Invoices",
                key: "finance-desk-performa",
                component: AllInvoices,
                rights: "financeInvoices.view",
                subRights: ["financeInvoices.view"],
            },
            // {
            //     path: '/grouped-performa-invoice',
            //     name: "Grouped Performa Invoice",
            //     title: 'Grouped Performa Invoice',
            //     key: 'grouped-performa-invoice',
            //     component: AllInvoices,
            //     rights: "financeInvoices.view",
            //     subRights: ["financeInvoices.view"],
            // },
            // {
            //     path: "/finance-desk-invoice",
            //     name: "Formal Invoices",
            //     title: "Formal Invoices",
            //     key: "finance-desk-invoice",
            //     component: AllInvoices,
            //     rights: "financeInvoices.view",
            //     subRights: ["financeInvoices.view"],
            // },
            // {
            //     path: "/finance-desk-pending",
            //     name: "Payment Pending Invoices",
            //     title: "Payment Pending Invoices",
            //     key: "finance-desk-pending",
            //     component: AllInvoices,
            //     rights: "financeInvoices.view",
            //     subRights: ["financeInvoices.view"],
            // },
            // {
            //     path: "/finance-desk-received",
            //     name: "Payment Received Invoices",
            //     title: "Payment Received Invoices",
            //     key: "finance-desk-received",
            //     component: AllInvoices,
            //     rights: "financeInvoices.view",
            //     subRights: ["financeInvoices.view"],
            // },
            {
                path: "/withdraw-desk",
                name: "Withdrawn Students",
                title: "Withdrawn Students",
                subRights: [
                    "financeWithdrawDesk.view",
                    "financeWithdraw.view",
                    "financeWithdrawStudents.view",
                ],
                children: [
                    {
                        path: "/account-withdraw-desk",
                        name: "Withdrawal Review",
                        // name: "Account Withdraw Desk",
                        title: "Withdrawal Review",
                        key: "account-withdraw-desk",
                        component: AllFinanceWithdrawdesk,
                        rights: "financeWithdrawDesk.view",
                    },
                    // {
                    //     path: "/finance-withdraw-requests",
                    //     name: "Student Withdrawals (Final Stage)",
                    //     title: "Student Withdrawals (Final Stage)",
                    //     key: "finance-withdraw-requests",
                    //     component: AllWithdrawFinalStage,
                    //     rights: "financeWithdraw.view",
                    // },
                    {
                        path: "/finance-withdraw-list",
                        name: "Withdrawn",
                        // name: "Non-Commissionable Students",
                        title: "Withdrawn",
                        key: "finance-withdraw-list",
                        component: AllWithdrawStudents,
                        rights: "financeWithdrawStudents.view",
                    }
                ]
            },
            {
                path: "/finance-branch-requests",
                name: "Branch Invoices to be paid",
                title: "Branch Invoices to be paid",
                key: "finance-branch-requests",
                component: AllFinanceBranchRequests,
                rights: "financeBranchRequests.view",
            },
            {
                path: "/finance-branch-claim-desk",
                name: "Branch Claims",
                title: "Branch Claims",
                key: "finance-branch-claim-desk",
                component: AllBranchClaimDesk,
                rights: "financeBranchClaimDesk.view",
            },
            {
                path: "/finance-branch-invoices",
                name: "Branch Invoices",
                title: "Branch Invoices",
                key: "finance-branch-invoices",
                component: AllBranchInvoices,
                rights: "financeBranchInvoices.view",
            },
            {
                path: "/company-details",
                name: "Commission Information",
                title: "Commission Inforamation",
                subRights: [
                    "financeUniversityCommission.view",
                    "financeCourseCommission.view",
                    "financeTax.view",
                    "financeCompanyDetails.view",
                    "CommunicationSetting.view",
                    "financeInvoiceTo.view",
                    "pendingIncentives.view",
                ],
                children: [
                    // Pending Incentives
                    // {
                    //     path: "/pending-incentives",
                    //     name: "Previous Incentives",
                    //     title: "Previous Incentives",
                    //     component: PreviousIncentives,
                    //     key: "previousIncentives",
                    //     rights: "pendingIncentives.view",
                    // },
                    // {
                    //     path: "/finance-university-commission",
                    //     name: "University Commission",
                    //     title: "University Commission",
                    //     key: "finance-university",
                    //     component: AllUniversityCommissions,
                    //     rights: "financeUniversityCommission.view",
                    // },
                    {
                        path: "/university-commission",
                        name: "University Commission",
                        title: "University Commission",
                        key: "finance-university",
                        component: UniversityCommission,
                        rights: "financeUniversityCommission.view",
                    },
                    {
                        path: '/channel-partner-commission',
                        name: 'Channel Partner Commission',
                        title: 'Channel Partner Commission',
                        key: 'channel-partner-commission',
                        component: ChannelPartnerCommission,
                        rights: 'financeUniversityCommission.view'
                    },
                    {
                        path: "/finance-course-commission",
                        name: "Course Commission",
                        title: "Course Commission",
                        key: "finance-course",
                        component: AllCourseCommission,
                        rights: "financeCourseCommission.view",
                    },
                    {
                        path: "/finance-tax",
                        name: "Tax",
                        title: "Tax",
                        key: "finance-tax",
                        component: AllTaxes,
                        rights: "financeTax.view",
                    },
                    {
                        path: "/company-info",
                        name: "Company Info",
                        title: "Company Info",
                        key: "company-info",
                        component: AllCompanyDetails,
                        rights: "financeCompanyDetails.view",
                    },
                    {
                        path: "/invoice-settings",
                        name: "Invoice Setting",
                        key: "InvoiceSettings",
                        title: 'Invoice',
                        component: AllInvoiceSettings,
                        rights: "financeInvoiceSetting.view",
                    },
                    {
                        path: "/invoice-to-details",
                        name: "Invoice Recipients",
                        title: "Invoice Recipients",
                        key: "invoice-to-details",
                        component: AllInvoiceToDetails,
                        rights: "financeInvoiceTo.view",
                    }
                ]
            }
        ]
    },
    // IP Management
    {
        name: "IP Management / Securities",
        key: "ipManagement",
        icon: (
            <i className={"anticon"}>
                <FaPlug />
            </i>
        ),
        authority: ["admin"],
        dontShowOnMenu: true,
        children: [
            {
                path: "/ip/add",
                name: "Authorized IP`s",
                title: "Authorized IP`s",
                component: AddIp,
                rights: "IpManagement.add",
            },
            {
                path: "/list/notAllowedIps",
                name: "Unauthorized IP`s",
                title: "Unauthorized IP`s",
                key: "allNotAllowedIps",
                component: allNotAllowedIps,
                rights: "IpManagement.view",
            },
        ],
    },


    // Social Media Integrations
    // {
    //     path: "/campaigns/facebook",
    //     icon: (
    //         <i className={"anticon"}>
    //             <FaBezierCurve />
    //         </i>
    //     ),
    //     name: "Social Media Integrations",
    //     key: "Integrations",
    //     title: 'Social Media Integrations', 
    //     subRights: [
    //         "SocialFacebook.view", 
    //         "SocialGoogle.view",
    //     ],      
    //     children: [
    //         {
    //             path: "/campaigns/facebook",
    //             name: "Facebook",
    //             title: "Facebook Lead",
    //             component: FacebookInquiry,
    //             rights: "SocialFacebook.view"
    //         },
    //         {
    //             path: "/campaigns/google",
    //             name: "Google",
    //             title: "Google Lead",
    //             component: GoogleInquiry,
    //             rights: "SocialGoogle.view"
    //         }
    //     ]
    // },
    // Registration Management Due Fees
    {
        path: "/desk/fee",
        icon: "table",
        name: "Registration",
        key: "registration",
        dontShowOnMenu: true,
        authority: ["admin", "user"],
        subRights: [],
        children: [
            {
                path: "/registration/fees",
                name: "Registration Desk",
                title: "Registration Desk",
                key: "fee",
                component: AddRegistrationFees,
                rights: "RegistrationDesk.view",
            },
        ],
    },

    // Important Contacts

    // {
    //     path: "/notification-templates",
    //     name: "Notification Templates",
    //     icon: (
    //         <i className={"anticon"}>
    //             <AiFillAlert />

    //         </i>
    //     ),
    //     key: "notification Templates",
    //     title: "All Notifications Templates",
    //     component: notificationTemplates,
    //     authority: ["admin", "user"],
    //     rights: "Student.view",
    // },
    // Social Integrations

    // Knowledge Base
    // {
    //     path: "/knowledge-base",
    //     icon: (
    //         <i className={"anticon"}>
    //             <FaBookOpen />
    //         </i>
    //     ),
    //     name: "Knowledge Base",
    //     title: "Knowledge Base",
    //     key: "knowledge-base",
    //     subRights: ["KnowledgeBase.view", "Category.view", "ShowKnowledgeBase.view"],
    //     authority: ["admin", "user"],
    //     children: [
    //         {
    //             path: "/show-knowledge-base",
    //             name: "View",
    //             title: "View",
    //             component: ShowKnowledge,
    //             key: "show-knowledge-base",
    //             rights: "ShowKnowledgeBase.view",
    //         },
    //         {
    //             path: "/knowledge-base",
    //             name: "List",
    //             title: "List",
    //             component: AllKnowledge,
    //             key: "all-knowledge-base",
    //             rights: "KnowledgeBase.view",
    //         },
    //         {
    //             path: "/add-knowledge-base",
    //             name: "Add Knowledge Base",
    //             title: "Add knowledge Base",
    //             component: AddKnowledge,
    //             key: "add-knowledge-base",
    //             rights: "KnowledgeBase.add",
    //             dontShowOnMenu: true,
    //         },
    //         {
    //             path: "/edit-knowledge-base",
    //             name: "Edit Knowledge Base",
    //             title: "Edit knowledge Base",
    //             component: AddKnowledge,
    //             key: "edit-knowledge-base",
    //             rights: "KnowledgeBase.edit",
    //             dontShowOnMenu: true,
    //         },
    //         {
    //             path: "/knowledgebase/category",
    //             name: "Categories",
    //             title: "Categories",
    //             key: "all-categories",
    //             component: AllKnowledgeBaseCategory,
    //             rights: "Category.view",
    //         },
    //         {
    //             path: "/knowledgebase/add-category",
    //             name: "Add Category",
    //             title: "Add Category",
    //             key: "add-category",
    //             component: AddKnowledgeBaseCategory,
    //             rights: "Category.add",
    //             dontShowOnMenu: true,
    //         },
    //         {
    //             path: "/knowledgebase/edit-category",
    //             name: "Edit Category",
    //             title: "Edit Category",
    //             key: "edit-category",
    //             component: AddKnowledgeBaseCategory,
    //             dontShowOnMenu: true,
    //         },
    //     ],

    // },
    // Activity
    {
        path: "/activity",
        name: "Activity",
        title: "Activity",
        key: "activity",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        component: Activity,
        subRights: [],
    },
    {
        path: "/communication-history",
        name: "Communication History",
        title: "Communication History",
        key: "communication-history",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        component: CommunicationHistory,
        subRights: [],
    },
    // Activity
    {
        path: "/rating-history",
        name: "Rating History",
        title: "Rating History",
        key: "rating-history",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        component: RatingHistory,
        subRights: [],
    },
    // Student Search
    {
        path: "/student-search",
        name: "Student Search",
        title: "Student Search",
        key: "student-search",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        component: StudentSearch,
        subRights: [],
    },
    // Student Moved reasons
    {
        path: "/student-moved-reason-notes",
        name: "Student Moved Reason Notes",
        title: "Student Moved Reason Notes",
        key: "student-moved-reason-notes",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        component: StudentMoveReasons,
        subRights: [],
    },
    // Claim Processing
    {
        path: "/desk/getClaim",
        name: "Claim Processing",
        title: "Claim Processing",
        key: "claimProcessing",
        component: ClaimProcessing,
        dontShowOnMenu: true,
        rights: "ClaimDesk.view",
    },
    // Visa Processing
    {
        path: "/desk/getVisa",
        name: "Visa Processing",
        title: "Visa Processing",
        key: "visaProcessing",
        component: VisaProcessing,
        dontShowOnMenu: true,
        rights: "VisaDesk.view",
    },
    // Application Desk   
    {
        path: "/desk/allApplication-desk/update",
        name: "Application Desk",
        title: "Application Desk",
        component: EditApplication,
        key: "editApplication",
        dontShowOnMenu: true,
        rights: "ApplicationDesk.view",
    },
    // Update Conselling
    {
        path: "/desk/update-counselling",
        name: "Update Counselling",
        title: "Update Counselling",
        key: "updateCousenlling",
        component: AddCounselling,
        dontShowOnMenu: true,
        rights: "CounsellingDesk.view",
    },
    // studentProfileDetails
    {
        path: "/inquiry/studentProfileDetails",
        name: "studentProfileDetails",
        title: "studentProfileDetails",
        key: "studentProfileDetails",
        component: studentDetailsDesign,
        dontShowOnMenu: true,
    },
    // update Lead 
    {
        path: "/inquiry/update",
        name: "update Lead",
        title: "update Lead",
        key: "inquiryedit1",
        component: EditInq1,
        dontShowOnMenu: true,
    },
    {
        path: "/inquiry/editV2",
        name: "Edit Inquiry V2",
        title: "Edit Inquiry V2",
        key: "inquiryeditv2",
        component: EditInquiryV2,
        dontShowOnMenu: true,
    },
    // addFamilyAndFinance
    {
        path: "/getFamilyAndFinance",
        name: "addFamilyAndFinance",
        title: "addFamilyAndFinance",
        key: "addFamilyAndFinance",
        component: AddFamilyFinance,
        dontShowOnMenu: true,
    },
    // Student Call History
    {
        path: "/student-call-history",
        name: "Student Call History",
        title: "Student Call History",
        key: "student-call-history",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        component: studentCallHistory,
        subRights: [],
    },
    // Document
    {
        path: "/documents",
        name: "Document",
        title: "Document",
        key: "documents",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        component: StudentDocument,
        subRights: [],
    },
    // Incentive Desk
    {
        path: "/incentive_desk/view",
        name: "Incentive Desk",
        title: "Incentive Desk",
        component: IncentiveDesk,
        key: "incentiveDesk",
        authority: ["admin", "user"],
        dontShowOnMenu: true,
        rights: "IncentiveDesk.view",
        subRights: ["IncentiveDesk.view"],
    },
    // Courier
    {
        path: "/getCourierDetails",
        name: "Courier",
        title: "Courier",
        key: "courier",
        authority: ["admin", "user"],
        subRights: [],
        dontShowOnMenu: true,
        component: Courier,
    },

    // Reports  
    {
        path: "/reports",
        name: "Reports",
        icon: (
            <i className={"anticon"}>
                <FaRegFileCode />
            </i>
        ),
        key: "report",
        title: "Reports",
        authority: ["admin", "user"],
        subRights: [
            "financeReports.view",
            "StudentReport.view",
            "CourseReport.view",
            "UniversityReport.view",
            "financeWalletReport.view",
            "vendorReports.view",
            // "CountryReport.view",
            // "ActivityReport.view",
            // "BusinessReport.view",
            // "GraphicalReport.view",
            // "UserWiseGraphicalReport.view",
            // "LibraryReport.view",
            // "overallReport.view",
            "ApplicationReport.view",
            "VisaDepartment.view",
            "callsReport.view",
            "counsellorConversionReport.view",
            "visitorVisaReport.view"
            // "TargetForCounsellor.view",
            // "CounsellorPerformanceRatio.view",
            // "InquiryConversionsReport.view",
            // "DeadInquiryReport.view"
        ],
        children: [
            {
                path: '/reports/consultancyFee',
                name: 'Consultancy Fee Report',
                title: 'Consultancy Fee Report',
                component: consultancyFeeReport,
                rights: "consultancyFeeReport.view",
            },
            {
                path: '/reports/counsellor-Performance',
                name: 'Counsellor Performance Report',
                title: 'Counsellor Performance Report',
                component: counsellorPerformanceReport,
                rights: "counsellorPerformanceReport.view",
            },
            {
                path: '/reports/counsellor-report',
                name: 'Counsellor Report',
                title: 'Counsellor Report',
                component: counsellorDailyReport,
                rights: "counsellorPerformanceReport.view",
            },
            {
                path: '/reports/student-account',
                name: 'Student Account Report',
                title: 'Student Account Report',
                component: StudentAccountReport,
                rights: "studentAccountReport.view",
            },
            {
                path: '/reports/university-account',
                name: 'University Account Report',
                title: 'University Account Report',
                component: UniversityAccountReport,
                rights: "studentAccountReport.view",
            },
            {
                path: '/reports/channel-partner-account',
                name: 'Channel Partner Report',
                title: 'Channel Partner Report',
                component: ChannelPartnerAccountReport,
                rights: "channelPartnerAccountReport.view",
            },
            {
                path: '/reports/branch-account',
                name: 'Branch Account Report',
                title: 'Branch Account Report',
                component: BranchAccountReport,
                rights: "branchAccountsReport.view",
            },
            // {
            //     path: "/universityReport",
            //     name: "Institutions",
            //     title: "Institutions",
            //     component: UniversityReport,
            //     rights: "UniversityReport.view",
            // },
            {
                path: "/courseReport",
                name: "Courses",
                title: "Courses",
                component: CourseReport,
                rights: "CourseReport.view",
            },
            // {
            //     path: "/studentReport",
            //     name: "Students",
            //     title: "Students",
            //     component: StudentReport,
            //     rights: "StudentReport.view",
            // },
            {
                path: "/applications-report",
                name: "Admission",
                title: "Admission",
                key: "applications-report",
                component: ApplicationsReports,
                rights: "ApplicationReport.view",
            },
            {
                path: "/visa-department",
                name: "Visa",
                title: "Visa",
                key: "visa-department",
                component: VisaDepartmentReport,
                rights: "VisaDepartment.view",
            },
            {
                path: "/visa-approved-report",
                name: "Visa Approval Report",
                title: "Visa Approval Report",
                key: "visa-department",
                component: visaApprovalReport,
                rights: "VisaDepartment.view",
            },
            {
                path: "/visa-submission-approval-report",
                name: "Visa Submission & Result Report",
                title: "Visa Submission & Result Report",
                key: "visa-department",
                component: visaSubmissionApprovalReport,
                rights: "VisaDepartment.view",
            },
            {
                path: "/finance-reports",
                name: "Finance",
                title: "Finance",
                key: "finance-reports",
                component: AllReports,
                rights: "financeReports.view",
            },
            {
                path: '/finance-wallet-report',
                name: 'Finance Wallet Report',
                title: 'Finance Wallet Report',
                key: 'finance-wallet',
                component: FinanceWalletReport,
                rights: 'financeWalletReport.view',
            },
            {
                path: '/vendor-report',
                name: 'Forex Vendor Report',
                title: 'Forex Vendor Report',
                key: 'vendor-report',
                component: VendorReport,
                rights: 'vendorReports.view'
            },
            {
                path: '/call-reports',
                name: 'Call Report',
                title: 'Call Report',
                key: "call-reports",
                component: CallsReport,
                rights: "callsReport.view"
            },
            {
                path: '/visitor-visa-report',
                name: 'Visitor Visa Report',
                title: 'Visitor Visa Report',
                key: 'visitor-visa-report',
                component: VisitorVisaReport,
                rights: 'visitorVisaReport.view'
            },
            // {
            //     path: '/overall-report',
            //     name: 'Overall Report',
            //     title: 'Overall Report',
            //     key: 'overall-report',
            //     component: BusinessReport
            // },
            // {
            //     path: '/counselling-conversion-report',
            //     name: 'Counsellor & Conversion Report',
            //     title: 'Counsellor & Conversion Report',
            //     key: 'counsellor-conversion-report',
            //     component: CounsellingConversionReport,
            //     rights: 'counsellorConversionReport.view'
            // },
            {
                path: '/branch-wise-conversion-report',
                name: 'Branch Wise Conversion Report',
                title: 'Branch Wise Conversion Report',
                key: 'branch-wise-conversion-report',
                component: ConversionReport,
                rights: 'counsellorConversionReport.view'
            },
            {
                path: '/counsellor-conversion',
                name: 'Counsellor Conversion Report',
                title: 'Counsellor Conversion Report',
                key: 'counsellor-conversion',
                component: CounsellorConversionReport,
                dontShowOnMenu: true,
            },

            {
                path: '/student-recruitment-metrics-report',
                name: 'Student Recruitment Metrics Report',
                title: 'Student Recruitment Metrics Report',
                key: 'student-recruitment-metrics-report',
                component: StudentRecruitmentMetricsReport,
                rights: 'studentRecruitmentMetricsReport.view'
            },
            {
                path: '/country-wise-student-report',
                name: 'Country Wise Student Report',
                title: 'Country Wise Student Report',
                key: 'country-wise-student-report',
                component: CountrywiseStudentReport,
                rights: 'countrywiseStudentReport.view'
            }
            // {
            //     path: "/countryReport",
            //     name: "Country",
            //     title: "Country",
            //     component: CountryReport,
            //     rights: "CountryReport.view",
            // },
            // {
            //     path: "/activityReport",
            //     name: "Activity",
            //     title: "Activity",
            //     component: ActivityReport,
            //     rights: "ActivityReport.view",
            // },
            // {
            //     path: "/businessReport",
            //     name: "Business",
            //     title: "Business",
            //     component: BuisnessReport,
            //     rights: "BusinessReport.view",
            // },
            // {
            //     path: "/graphicalReport",
            //     name: "Graphical",
            //     title: "Graphical",
            //     component: GraphicalReport,
            //     rights: "GraphicalReport.view",
            // },
            // {
            //     path: "/userWiseGraphicalReport",
            //     name: "UserWise Graphical",
            //     title: "UserWise Graphical",
            //     component: UserWiseReport,
            //     rights: "UserWiseGraphicalReport.view",
            // },
            // {
            //     path: "/libraryReport",
            //     name: "Library",
            //     title: "Library",
            //     component: LibraryReport,
            //     key: "libraryReport",
            //     rights: "LibraryReport.view",
            // },
            // {
            //     path: "/overall-report",
            //     name: "Overall",
            //     title: "Overall",
            //     key: "overall-report",
            //     component: AllOverallReports,
            //     rights: "overallReport.view",
            // },
            // {
            //     path: "/inquiry-conversions-report",
            //     name: "Inquiry Conversions",
            //     title: "Inquiry Conversions",
            //     key: "inquiry-conversions-report",
            //     component: InquiryConvertionReport,
            //     rights: "InquiryConversionsReport.view",
            // },
            // {
            //     path: "/dead-inquiry-report",
            //     name: "Dead Inquiry",
            //     title: "Dead Inquiry",
            //     key: "dead-inquiry-report",
            //     component: DeadInquiryReport,
            //     rights: "DeadInquiryReport.view",
            // }
        ]
    },
    // Campaign Leads
    {
        path: "/campaigns/facebook",
        name: "Campaign Leads",
        key: "Integrations",
        title: 'Campaign Leads',
        dontShowOnMenu: true,
        subRights: [
            "SocialFacebook.view",
            "SocialGoogle.view",
        ],
        children: [
            {
                path: "/campaigns/facebook",
                name: "Facebook",
                title: "Facebook Lead",
                component: FacebookInquiry,
                rights: "SocialFacebook.view"
            },
            {
                path: "/campaigns/google",
                name: "Google",
                title: "Google Lead",
                component: GoogleInquiry,
                rights: "SocialGoogle.view"
            }
        ]
    },
    {
        path: '/campaigns',
        icon: (
            <i className={"anticon"}>
                <FaCogs />
            </i>
        ),
        name: 'Campaigns',
        key: 'campaigns',
        title: 'Campaigns',
        subRights: [
            "emailCampaign.view",
            "whatsappCampaign.view",
            "campaignHistory.view",
        ],
        children: [
            {
                path: '/campaign/email',
                name: 'Email',
                title: 'Email',
                component: EmailCampaign,
                rights: "emailCampaign.view"
            },
            {
                path: '/campaign/whatsapp',
                name: 'Whatsapp',
                title: 'Whatsapp',
                component: WhatsappCampaign,
                rights: 'whatsappCampaign.view'
            },
            {
                path: "/campaign/history",
                name: 'Campaign History',
                title: 'Campaign History',
                component: CampaignHistory,
                rights: 'campaignHistory.view'
            }
        ]
    },
    // Communication Setting
    {
        path: "/communication-settings",
        icon: (
            <i className={"anticon"}>
                <FaCogs />
            </i>
        ),
        name: "Communication Setting",
        key: "settings",
        title: 'Communication Setting',
        subRights: [
            "Template.view",
            "autoFollowUp.view",
            "AdminCommunication.view",
            "IVRSetting.view",
            "SearchLogs.view",
            "DirectCall.view",
            "SyncUsers.view",
            "SocialSetting.view"
        ],
        children: [
            {
                path: "/template/all-templates",
                name: "Template",
                title: "Template",
                component: AllTemplate,
                rights: "Template.view",
            },
            {
                path: "/template/edit-template",
                name: "Template ",
                title: "Template",
                key: "editTemplate",
                dontShowOnMenu: true,
                component: AllTemplate,
            },
            {
                path: "/communication-triggers",
                name: "Communication Triggers",
                title: "Communication Triggers",
                component: CommunicationTriggers,
                rights: "communicationTriggers.view"
            },
            {
                path: "/all-auto-follow-up",
                name: "Auto Follow Up",
                title: "Auto Follow Up",
                key: "auto-follow-up",
                authority: ["admin", "user"],
                children: [
                    {
                        path: "/all-auto-follow-up",
                        name: "List",
                        title: "List",
                        component: AllAutoFollowUp,
                        key: "all-auto-follow-up",
                        rights: "autoFollowUp.view",
                    },
                    {
                        path: "/add-auto-follow-up",
                        name: "Add",
                        title: "Add",
                        component: AddAutoFollowUp,
                        key: "add-auto-follow-up",
                        rights: "autoFollowUp.add",
                    },
                    {
                        path: "/edit-auto-follow-up",
                        name: "Edit",
                        title: "Edit",
                        key: "edit-auto-follow-up",
                        dontShowOnMenu: true,
                        component: AddAutoFollowUp,
                        rights: "autoFollowUp.edit",
                    }
                ],
            },
            {
                path: "/ivr-settings",
                title: "IVR Management",
                name: "IVR Management",
                key: "ivr-settings",
                authority: ["admin", "user"],
                children: [
                    {
                        path: "/search-logs",
                        name: "Search Logs",
                        title: "Search Logs",
                        key: "search-logs",
                        component: SearchLogs,
                        rights: "SearchLogs.view",
                    },
                    {
                        path: "/direct-call",
                        name: "Direct Call",
                        title: "Direct Call",
                        key: "direct-call",
                        component: DirectCall,
                        rights: "DirectCall.view",
                    },
                    {
                        path: "/sync-users",
                        name: "Sync Users",
                        title: "Sync Users",
                        key: "sync-users",
                        component: AllSyncUsers,
                        rights: "SyncUsers.view",
                    },

                ]
            },
            {
                path: "/adminCommunication",
                name: "Admin Communication",
                key: "communication",
                title: "Admin Communication",
                authority: ["admin", "user"],
                children: [
                    {
                        path: "/communication/email/all",
                        name: "Communication Emails",
                        title: "Communication Emails",
                        component: AllEmails,
                        target: "_blank",
                        rights: "AdminCommunication.view",
                    },
                    {
                        path: "/communication/sms/all",
                        name: "Communication Sms",
                        title: "Communication Sms",
                        component: AllSms,
                        target: "_blank",
                        rights: "AdminCommunication.view",
                    },
                ],
            },
        ]
    },
    // Integrations
    {
        path: "/Integrations",
        icon: (
            <i className={"anticon"}>
                <FaUsb />
            </i>
        ),
        name: "Integrations",
        key: "Integrations",
        title: 'Integrations',
        subRights: [
            "CommunicationSetting.view",
            "NotificationTemplates.view",
            "AdminCommunication.view",
            "IVRSetting.view",
            "SearchLogs.view",
            "DirectCall.view",
            "SyncUsers.view",
            "SocialSetting.view"
        ],
        children: [
            {
                path: "/email-settings",
                name: "Email",
                key: "EmailSettings",
                title: 'Communication',
                component: AllEmailSettings,
                rights: "CommunicationSetting.view",
            },
            {
                path: "/sms-settings",
                name: "SMS",
                key: "SmsSettings",
                title: 'SMS',
                component: AllSMSSettings,
                rights: "CommunicationSetting.view",
            },
            {
                path: "/whatsapp-settings",
                name: "WhatsApp",
                key: "WhatsAppSettings",
                title: 'WhatsApp',
                component: AllWhatsAppSettings,
                rights: "CommunicationSetting.view",
            },
            {
                path: "/ivr-settings",
                name: "IVR Settings",
                title: "IVR Settings",
                key: "ivr-settings",
                component: AllIVRSettings,
                rights: "IVRSetting.view",
            },
            {
                path: "/campaign",
                key: "FacebookCommunicationSettings",
                name: "Campaign",
                title: "Campaign",
                component: FacebookCommunicationSettings,
                rights: "SocialSetting.view"
            },

        ]
    },
    // Loyality Program
    {
        path: "/loyalty",
        name: "Loyalty Program",
        key: "loyalty",
        subRights: [
            'loyalityProgramCodes.view',
            'loyalityProgramMembers.view',
            "loyalityProgramDetails.view",
            "loyalityProgramSettings.view"
        ],
        icon: (
            <i className={"anticon"}>
                <RiCoinsFill />
            </i>
        ),
        title: "Loyalty Program",
        authority: ["admin", "user"],
        children: [
            {
                path: '/loyalty/codes',
                name: 'Program Codes',
                title: 'Program Codes',
                component: LoyalityCodes,
                rights: "loyalityProgramCodes.view"
            },
            {
                path: '/loyalty/members',
                name: 'Program Members',
                title: 'Program Members',
                component: LoyalityMembers,
                rights: "loyalityProgramMembers.view"
            },
            {
                path: '/loyalty/details',
                name: 'Program Details',
                title: 'Program Details',
                component: LoyalitySettings,
                rights: 'loyalityProgramDetails.view'
            },
            {
                path: '/loyalty/settings',
                name: 'Settings',
                title: 'Settings',
                component: ProgramSettings,
                rights: "loyalityProgramSettings.view"
            }
        ]
    },
    // Acoommodation Service
    {
        path: "/accomodation",
        name: 'Accomodation Service',
        icon: (
            <i className={"anticon"}>
                <FaServicestack />
            </i>
        ),
        title: 'Accomodation Service',
        component: AccomodationServiceView,
        rights: 'accomodationServices.view'
    },
    // Important Contacts
    {
        path: "/contactDetails",
        icon: (
            <i className={"anticon"}>
                <FaCertificate />
            </i>
        ),
        name: "Important Contacts",
        title: "Important Contacts",
        key: "Important Contacts",
        subRights: [],
        authority: ["admin", "user"],
        children: [
            {
                path: "/contactDetails",
                name: "Contact Details",
                title: "Contact Details",
                key: "contactDetails",
                rights: "Contact.view",
                component: AddContactDetails
            },
            {
                path: "/contactDetails/:id",
                name: "contactDetails",
                key: "editContactDetails",
                title: "contactDetails",
                component: AddContactDetails,
                dontShowOnMenu: true,
            },
            {
                path: "/staff-directory",
                name: "Staff Directory",
                title: "Staff Directory",
                key: "staffDirectory",
                component: StaffDirectory
            },

        ]
    },
    // Trobleshoots / Suggestions
    {
        path: "/company-rules",
        icon: (
            <i className={"anticon"}>
                <FaBug />
            </i>
        ),
        title: "Troubleshoot / Suggestions",
        name: "Troubleshoot / Suggestions",
        key: "trobleshoots-suggestions",
        authority: ["admin", "user"],
        subRights: [
            "companyRules.view",
            "staffSuggestions.view",
            "showSuggestions.view"
        ],
        children: [
            // {
            //     path: "/show-raised-suggestions",
            //     name: "Raised Ticket",
            //     title: "Raised Ticket",
            //     key: "show-raised-suggestions",
            //     component: ShowRaisedSuggestions,
            //     rights: "showRaisedSuggestions.view",
            // },
            {
                path: '/suggestions',
                name: 'Suggestions',
                title: 'Suggestions',
                key: 'add-suggestions',
                component: AllStaffSuggestions,
                rights: "staffSuggestions.view"
            },
            // {
            //     path: "/show-suggestions",
            //     name: "View Suggestions",
            //     title: "View Suggestions",
            //     key: "show-suggestions",
            //     component: ShowAllSuggestions,
            //     rights: "showSuggestions.view",
            // },
            {
                path: "/show-rules",
                name: "Rules",
                title: "Rules",
                key: "show-rules",
                component: AllCompanyRules,
                rights: "companyRules.view",
            },
        ]
    },
    // Knowledge Base
    {
        path: "/knowledge-base",
        icon: (
            <i className={"anticon"}>
                <FaBookOpen />
            </i>
        ),
        name: "Knowledge Base",
        title: "Knowledge Base",
        key: "knowledge-base",
        subRights: ["KnowledgeBase.view", "Category.view", "ShowKnowledgeBase.view"],
        authority: ["admin", "user"],
        children: [
            {
                path: "/show-knowledge-base",
                name: "View",
                title: "View",
                component: ShowKnowledge,
                key: "show-knowledge-base",
                rights: "ShowKnowledgeBase.view",
            },
            {
                path: "/knowledge-base",
                name: "List",
                title: "List",
                component: AllKnowledge,
                key: "all-knowledge-base",
                rights: "KnowledgeBase.view",
            },
            {
                path: "/add-knowledge-base",
                name: "Add Knowledge Base",
                title: "Add knowledge Base",
                component: AddKnowledge,
                key: "add-knowledge-base",
                rights: "KnowledgeBase.add",
                dontShowOnMenu: true,
            },
            {
                path: "/edit-knowledge-base",
                name: "Edit Knowledge Base",
                title: "Edit knowledge Base",
                component: AddKnowledge,
                key: "edit-knowledge-base",
                rights: "KnowledgeBase.edit",
                dontShowOnMenu: true,
            },
            {
                path: "/knowledgebase/category",
                name: "Categories",
                title: "Categories",
                key: "all-categories",
                component: AllKnowledgeBaseCategory,
                rights: "Category.view",
            },
            {
                path: "/knowledgebase/add-category",
                name: "Add Category",
                title: "Add Category",
                key: "add-category",
                component: AddKnowledgeBaseCategory,
                rights: "Category.add",
                dontShowOnMenu: true,
            },
            {
                path: "/knowledgebase/edit-category",
                name: "Edit Category",
                title: "Edit Category",
                key: "edit-category",
                component: AddKnowledgeBaseCategory,
                dontShowOnMenu: true,
            },
        ],
    },
    // Get Support
    {
        path: "/get-support",
        name: "Get Support",
        key: "getSupport",
        title: "Get Support",
        icon: (
            <i className={"anticon"}>
                <BiSupport />
            </i>
        ),
        component: getSupport,
        subRights: [],
        authority: ["admin", "user"],
    },
];

//<editor-fold desc="Functions Exports">

export const getUrlObject = (keyString) => {
    let keyArr = keyString.split(".");

    let val = _.find(menu, (p) => p.key === keyArr[0]);

    if (!val) {
        return `/`;
    }

    if (keyArr.length === 2) {
        val = _.find(val.children, (p) => p.key === keyArr[1]);
    }

    if (!val) {
        return `/`;
    }

    return val;
};

export const getUrlPushWrapper = (keyString, query) => {
    return push(getUrlPath(keyString, query));
};

export const getUrlQueryPushWrapper = (keyString, query) => {
    return push(getUrlQuery(keyString, query));
};

export const getUrlPathQueryPushWrapper = (path, params) => {
    let queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
    return push(`${path}?${queryString}`);
};

export const getUrlPath = (keyString, params) => {
    if (!params) params = {};

    let keyArr = keyString.split(".");

    let val = _.find(menu, (p) => p.key === keyArr[0]);

    if (!val) {
        return `/`;
    }

    if (keyArr.length === 2) {
        val = _.find(val.children, (p) => p.key === keyArr[1]);
    }

    if (!val) {
        return `/`;
    }

    let queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
    return `${val.path}?${queryString}`;
};

export const getPushPathWrapper = (keyString, params) => {
    let obj = getUrlObject(keyString);

    if (obj) {
        const path = new Path(obj.path);
        return push(path.build(params));
    }

    return "error";
};

export const getUrlParams = (keyString, route) => {
    let obj = getUrlObject(keyString);
    if (obj && obj.path) {
        const path = new Path(obj.path);
        return path.test(route);
    }
    return { error: true };
};

export const getUrlQuery = (keyString, params) => {
    if (!params) params = {};
    let keyArr = keyString.split(".");
    let val = _.find(menu, (p) => p.key === keyArr[0]);
    if (!val) {
        return `/`;
    }

    if (keyArr.length === 2) {
        val = _.find(val.children, (p) => p.key === keyArr[1]);
    }
    if (!val) {
        return `/`;
    }

    let queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

    return `${val.path}?${queryString}`;
};

export default menu;
